<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar Comprobante"
                        aria-label="Agregar Comprobante"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 230px; max-width: 340px;">
              <label class="filter-label">Proveedores</label>
              <v-select :options="arr.filters.suppliers" v-model="filters.suppliers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 230px; max-width: 340px;">
              <label class="filter-label">Categorías</label>
              <v-select :options="arr.filters.categories" v-model="filters.categories" placeholder="Todas" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="width: 190px;">
              <label class="filter-label">Vencimiento</label>
              <b-form-select v-model="filters.expiration_status" :options="arr.filters.expirationStatus" size="sm" />
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterPurchase()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-row>
              <b-col sm="12">
                <b-table class="app-table crud-purchase-table"
                        ref="table"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        sticky-header="60vh"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="table.items"
                        :fields="table.fields"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        :tbody-tr-class="rowClass"
                        @row-clicked="onRowClicked"
                        :busy="table.isBusy"
                        v-if="table.items.length || table.isBusy">

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template>

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(business)="data">
                      {{data.item.points_sales.business.reference}}
                    </template>

                    <template v-slot:cell(voucher)="data">
                      <div v-if="data.item.type_voucher && data.item.number">
                        <b-badge variant="dark" v-if="data.item.points_sales">
                          {{data.item.points_sales.point_sale}} - {{data.item.points_sales.name}}
                        </b-badge>
                        <b-badge variant="secondary" class="ml-1" v-if="data.item.purchase_category">
                          {{data.item.purchase_category.name}}
                        </b-badge>
                        <div>
                          {{data.item.type_voucher.name}}
                          {{data.item.point_sale.toString().padStart(4,'0') + '-' + data.item.number.toString().padStart(8,'0')}}
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(date)="data">
                      {{moment(data.item.date).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(date_expiration)="data">
                      <VoucherExpiration :date="data.item.date_expiration" :pending="isPendingPurchase(data.item)" />
                    </template>

                    <template v-slot:cell(suppliers_id)="data">
                      <div v-if="data.item.supplier">
                        <b-avatar :src="data.item.supplier.image"
                                  size="25px"
                                  v-if="data.item.supplier.image">
                        </b-avatar>
                        <b-avatar v-else
                                  size="25px"
                                  :text="avatarFromName(data.item.supplier.name).text"
                                  :style="avatarFromName(data.item.supplier.name).style">
                        </b-avatar>
                        &nbsp;<b>{{data.item.supplier.name}}</b>

                        <AppIcon name="circle-fill" v-if="!data.item.supplier.active" class="ml-2 text-danger" v-b-tooltip.hover title="Proveedor INACTIVO" />
                      </div>
                    </template>

                    <template v-slot:cell(amount_total)="data">
                      <div v-if="data.item.currency">
                        <div class="text-success" v-if="data.item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount_total)}}</b>
                        </div>
                        <div class="text-danger" v-else>
                          <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount_total)}})</b>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(amount_pending)="data">
                      <div v-if="data.item.currency">
                        <div class="text-danger" v-if="data.item.type_voucher.type_balance == '+' && data.item.amount_total!=data.item.amount_impute">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(getPendingVoucherPurchase(data.item))}}</b>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(info_payment)="data">
                      <div v-if="data.item.info_payment">
                        <span v-if="isMobileViewport">{{data.item.info_payment.name}}</span>
                        <span v-else v-b-tooltip.hover :title="data.item.info_payment.name">
                          <AppIcon name="sticky_note_2" />
                        </span>
                      </div>
                    </template>

                    <template v-slot:cell(observations)="data">
                      <div v-if="data.item.file || data.item.observations">
                        <template v-if="isMobileViewport">
                          <div v-if="data.item.file">
                            <b-link target="blank" :href="data.item.file"><AppIcon name="paperclip" class="mr-1" />Ver documento adjunto</b-link>
                          </div>
                          <div v-if="data.item.observations">{{data.item.observations}}</div>
                        </template>
                        <template v-else>
                          <b-link target="blank" :href="data.item.file" v-if="data.item.file" v-b-tooltip.hover.right title="Ver documento adjunto" class="mr-1">
                            <AppIcon name="paperclip" />
                          </b-link>
                          <span v-if="data.item.observations" v-b-tooltip.hover :title="data.item.observations">
                            <AppIcon name="chat-square-text" />
                          </span>
                        </template>
                      </div>
                    </template>

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'crud-purchase-action-toggle-labeled' : 'app-table-action-toggle'"
                                  :class="{ 'pull-right': !isMobileViewport }">
                        <template #button-content>
                          <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                          <span v-if="isMobileViewport">Opciones</span>
                        </template>

                        <b-dropdown-item @click="openSub(data.item)">
                          <AppIcon name="visibility" /> Visualizar
                        </b-dropdown-item>
                        <b-dropdown-item @click="openSetRemits(data.item)" v-if="data.item.type_voucher.type_balance == '+'">
                          <AppIcon name="truck" /> Remitos
                        </b-dropdown-item>
                        <b-dropdown-item @click="generatePayment(data.item)" v-if="canGeneratePayment(data.item)">
                          <AppIcon name="money" /> Pago
                        </b-dropdown-item>
                        <b-dropdown-item @click="openSetFile(data.item)">
                          <AppIcon name="paperclip" /> Documento Físico
                        </b-dropdown-item>
                        <b-dropdown-item @click="openSetExtra(data.item)">
                          <AppIcon name="edit" /> Edición rápida
                        </b-dropdown-item>

                        <b-dropdown-header v-if="!data.item.payments.length || (!data.item.payments.length && access.elements.deletePurchase)">Acciones</b-dropdown-header>
                        <b-dropdown-item @click="edit(data.item)" v-if="!data.item.payments.length">
                          <AppIcon name="edit" /> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="remove(data.item)" v-if="!data.item.payments.length && access.elements.deletePurchase">
                          <AppIcon name="delete" class="text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else
                            icon="reports"
                            title="No se encontraron comprobantes"
                            description="Ajustá los filtros o el rango de fechas para ampliar la búsqueda, o generá un comprobante nuevo con el botón Agregar." />

                <div class="app-table-footer">
                  <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
                  <export-excel
                      class="list-view-link"
                      :data="arr.export"
                      worksheet="Listado de Compras"
                      name="list-purchase.xls">
                      <AppIcon name="download" class="mr-1" /> Exportar
                  </export-excel>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- DRAWER: detalle del comprobante seleccionado -->
      <b-sidebar
          id="sidebar-purchase-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Comprobante"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.type_voucher && itemSelected.number">
                {{itemSelected.type_voucher.name}} {{itemSelected.point_sale.toString().padStart(4,'0') + '-' + itemSelected.number.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.supplier">
                {{itemSelected.supplier.name}}
              </div>
              <div class="list-view-drawer__meta" v-if="itemSelected.date">
                {{moment(itemSelected.date).format('DD/MM/YYYY')}}
              </div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrevPurchase"
                        v-b-tooltip.hover
                        title="Comprobante anterior"
                        @click="goPrevPurchase()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNextPurchase"
                        v-b-tooltip.hover
                        title="Comprobante siguiente"
                        @click="goNextPurchase()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Total</span>
              <span class="list-view-drawer__stat-value">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(itemSelected.amount_total)}}
              </span>
            </div>
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': itemSelected.amount_total != itemSelected.amount_impute }">
              <span class="list-view-drawer__stat-label">Pendiente</span>
              <span class="list-view-drawer__stat-value">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(getPendingVoucherPurchase(itemSelected))}}
              </span>
            </div>
          </div>

          <div v-if="itemSelected.observations" class="crud-purchase-drawer-observations">
            <div class="list-view-drawer__section-title">
              <AppIcon name="chat-square-text" /> Observaciones
            </div>
            <div class="crud-purchase-observations-content">{{itemSelected.observations}}</div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="percent" /> IVA
            </div>
            <b-table  class="app-table app-table--compact"
                      responsive
                      :stacked="isMobileViewport ? 'md' : false"
                      :hover="true"
                      :small="true"
                      :fixed="true"
                      :items="tableSubIva.items"
                      :fields="tableSubIva.fields"
                      v-if="tableSubIva.items.length">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template>

              <template v-slot:cell(iva_condition)="data">
                {{data.item.iva_condition.name}}
              </template>

              <template v-slot:cell(amount_net)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_net)}}
              </template>

              <template v-slot:cell(amount_iva)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_iva)}}
              </template>

              <template v-slot:cell(amount_total)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_total)}}
              </template>
            </b-table>
            <EmptyState v-else icon="percent" title="Sin discriminación de IVA" />
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="receipt_long" /> Percepciones
            </div>
            <b-table  class="app-table app-table--compact"
                      responsive
                      :stacked="isMobileViewport ? 'md' : false"
                      :hover="true"
                      :small="true"
                      :fixed="true"
                      :items="tableSubPercepcion.items"
                      :fields="tableSubPercepcion.fields"
                      v-if="tableSubPercepcion.items.length">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template>

              <template v-slot:cell(percepcion)="data">
                <span v-if="data.item.percepciones">{{data.item.percepciones.name}}</span>
              </template>

              <template v-slot:cell(amount_total)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_total)}}
              </template>
            </b-table>
            <EmptyState v-else icon="receipt_long" title="Sin discriminación de Percepciones" />
          </div>

          <div v-if="tableSubRemits.items.length">
            <div class="list-view-drawer__section-title">
              <AppIcon name="truck" /> Remitos
            </div>
            <b-table  class="app-table app-table--compact"
                      responsive
                      :stacked="isMobileViewport ? 'md' : false"
                      :hover="true"
                      :small="true"
                      :fixed="true"
                      :items="tableSubRemits.items"
                      :fields="tableSubRemits.fields">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template>

              <template v-slot:cell(date)="data">
                {{moment(data.item.data.date).format('DD/MM/YYYY')}}
              </template>

              <template v-slot:cell(remits)="data">
                {{data.item.data.type_voucher.name}} {{data.item.data.point_sale.toString().padStart(4,'0') + '-' + data.item.data.number.toString().padStart(8,'0')}}
              </template>
            </b-table>
          </div>

          <b-alert v-if="getPurchaseRemitsDifference(itemSelected)" show variant="info" class="mb-3">
            <AppIcon name="info-circle" class="mr-1" />
            <b>Mensaje informativo:</b> el importe neto de la factura ({{ formatPurchaseRemitAmount(getPurchaseRemitsDifference(itemSelected).invoiceAmount, itemSelected) }}) difiere del importe neto de los ítems de remito vinculados ({{ formatPurchaseRemitAmount(getPurchaseRemitsDifference(itemSelected).remitAmount, itemSelected) }}).
          </b-alert>

          <div v-if="tableImputation.items.length">
            <div class="list-view-drawer__section-title">
              <AppIcon name="link" /> Imputaciones
            </div>
            <b-table  class="app-table app-table--compact"
                      responsive
                      :stacked="isMobileViewport ? 'md' : false"
                      :hover="true"
                      :small="true"
                      :fixed="true"
                      :items="tableImputation.items"
                      :fields="tableImputation.fields">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template>

              <template v-slot:cell(date)="row">
                {{moment(row.item.date).format('DD/MM/YYYY')}}
              </template>

              <template v-slot:cell(reference)="row">
                {{row.item.reference}}
              </template>

              <template v-slot:cell(amount_total)="row">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(row.item.amount_total)}}
              </template>
            </b-table>
          </div>

          <b-button block
                    size="sm"
                    variant="outline-secondary"
                    class="text-left"
                    @click="openDetail()">
            <AppIcon name="visibility" class="mr-1" /> Ver detalle completo
          </b-button>

          <!-- En mobile el kebab de la fila no va (ver loadFieldTable): las
               mismas acciones quedan acá, ya desplegadas. En desktop también
               se muestran, como atajo además del kebab. -->
          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="openSetRemits(itemSelected)" v-if="itemSelected.type_voucher.type_balance == '+'">
              <AppIcon name="truck" class="mr-1" /> Remitos
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="generatePayment(itemSelected)" v-if="canGeneratePayment(itemSelected)">
              <AppIcon name="money" class="mr-1" /> Pago
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="openSetFile(itemSelected)">
              <AppIcon name="paperclip" class="mr-1" /> Documento Físico
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="openSetExtra(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Edición rápida
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="edit(itemSelected)" v-if="!itemSelected.payments.length">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <!-- Eliminar: siempre al fondo del sidebar, aparte del contenido
             scrolleable — la acción destructiva no compite con el resto. -->
        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && !itemSelected.payments.length && access.elements.deletePurchase">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate">
                <b-pagination class="mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterPurchase()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-alert show variant="info" v-if="crud.form.remits_id" class="crud_purchase_alert_from">
          <b>Desde {{getRemitReference}}</b>
        </b-alert>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="preSave"
                      class="crud-purchase-wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="purchaseValidDetailGeneral">
            <b-row>
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha Vencimiento">
                  <b-form-datepicker size="sm" v-model="crud.form.date_expiration" placeholder="Fecha Vencimiento" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha Imputación">
                  <b-form-datepicker size="sm" v-model="crud.form.date_imputation" placeholder="Fecha Imputación" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FindObject type="suppliers"
                            render="search"
                            @select-object="loadSuppliers($event)"
                            :valueID="crud.form.suppliers_id"
                            :key="'finder_suppliers_'+componentKey"
                            :where="conditionSuppliersActive"
                            :disabled="crud.form.id>0 || crud.form.remits_id>0" />
              </b-col>
              <b-col md="4">
                <FindObject tag="Punto de Venta (Imputación)"
                            type="erpPointsSales"
                            render="search"
                            display="full_identification"
                            @select-object="loadPointsSales($event)"
                            :valueID="crud.form.points_sales_id"
                            :key="'finder_point_sale_'+componentKeyAlt"
                            auto-select-single
                            :disabled="crud.form.id>0 || crud.form.remits_id>0"
                            :where="conditionPointsSalesActive" />
              </b-col>
              <b-col md="4">
                <FindObject type="currency"
                            render="search"
                            auto-select-single
                            @select-object="loadCurrency($event)"
                            :key="'finder_currency_'+componentKey"
                            :valueID="crud.form.currency_id"
                            :where="conditionCurrencyActive"
                            :disabled="crud.form.id>0"/>
              </b-col>
            </b-row>
            <b-row v-if="canShowPurchaseCategory || canShowPurchaseInfoPayment">
              <b-col md="4" v-if="canShowPurchaseCategory">
                <FindObject type="purchaseCategory"
                            render="search"
                            @select-object="loadPurchaseCategory($event)"
                            :valueID="crud.form.purchase_category_id"/>
              </b-col>
              <b-col md="4" v-if="canShowPurchaseInfoPayment">
                <FindObject type="purchaseInfoPayment"
                            render="search"
                            @select-object="loadInfoPayment($event)"
                            :valueID="crud.form.info_payment_id"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
              </b-col>
            </b-row>
            <b-row align-h="between">
              <b-col md="9" v-if="crud.form.suppliers_id">
                <div class="crud-purchase-voucher-fields">
                  <div class="crud-purchase-voucher-fields__title">
                    <AppIcon name="receipt" /> Datos del comprobante
                  </div>
                  <b-row>
                  <b-col md="4">
                    <b-form-group label="Tipo">
                      <b-form-select v-model="crud.form.types_vouchers_id"
                                    :options="arr.select.typeVouchers"
                                    @change="setLetter($event)"
                                    size="sm"
                                    :disabled="crud.form.id>0">
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Punto de Venta">
                      <app-text-input v-model.number="crud.form.point_sale"
                                      type="text"
                                      inputmode="numeric"
                                      :allowed-pattern="/[0-9]/g"
                                      size="sm"
                                      maxlength="6" />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Número">
                      <app-text-input v-model.number="crud.form.number"
                                      type="text"
                                      inputmode="numeric"
                                      :allowed-pattern="/[0-9]/g"
                                      size="sm"
                                      maxlength="10" />
                    </b-form-group>
                  </b-col>
                </b-row>
                </div>
              </b-col>
              <b-col md="3" :offset="crud.form.suppliers_id ? 0 : 9">
                <b-form-group label="Importe Final" description="Ingrese el importe final de la factura">
                  <b-input-group size="md" prepend="$">
                    <app-number-input v-model="crud.form.amount_total" placeholder="Ingrese el importe final" />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Impuestos" icon="fa fa-percent" :before-change="purchaseValidItemDetail" v-if="crud.form.letter == 'A'" :key="'tab_b_'+componentKey">
            <b-tabs class="crud-purchase-tax-tabs" content-class="pt-3">
              <b-tab active>
                <template #title>
                  <AppIcon name="percent" class="mr-1" /> IVA discriminado
                  <b-badge pill variant="secondary" class="ml-1">{{ crud.form.ivaDetail.detail.length }}</b-badge>
                </template>

                <div class="crud-purchase-tax-guide">
                  <AppIcon name="info-circle" />
                  <span><b>¿Cómo cargar el IVA?</b> Elegí la alícuota, ingresá el neto gravado y verificá el importe calculado antes de agregarlo al comprobante.</span>
                </div>

                <div class="crud-purchase-tax-form">
                  <b-row align-v="end">
                    <b-col md="3">
                      <b-form-group label="Condición IVA">
                        <b-form-select v-model="crud.form.ivaDetail.iva_condition_id"
                                      :options="arr.select.ivaCondition"
                                      @input="changeIvaCondition($event)"
                                      size="sm">
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col md="3">
                      <b-form-group label="Neto gravado">
                        <b-input-group size="sm" prepend="$">
                          <app-number-input v-model="crud.form.ivaDetail.net" @change="changeNet()" placeholder="Ingrese el neto" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col md="3">
                      <b-form-group label="Importe IVA" v-if="crud.form.ivaDetail.iva_condition">
                        <b-input-group size="sm" prepend="$">
                          <app-number-input v-model="crud.form.ivaDetail.iva"
                                            :key="'iva_amount_' + crud.form.ivaDetail.iva_condition_id"
                                            placeholder="Ingrese el IVA"
                                            @keyup.enter.native="addItemIVA()"
                                            :disabled="!parseFloat(crud.form.ivaDetail.iva_condition.aliquot)">
                          </app-number-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col md="3" class="d-flex align-items-end">
                      <b-button size="sm" variant="primary" class="crud-purchase-tax-form__add" @click="addItemIVA()">
                        <AppIcon name="plus-circle" class="mr-1" /> Agregar IVA
                      </b-button>
                    </b-col>
                  </b-row>
                </div>

                <div class="crud-purchase-tax-detail">
                  <div v-if="crud.form.ivaDetail.detail && crud.form.ivaDetail.detail.length" class="crud-purchase-tax-table">
                    <div class="crud-purchase-tax-table__heading">
                      <span><AppIcon name="percent" /> IVA incorporado</span>
                      <b-badge pill variant="secondary">{{ crud.form.ivaDetail.detail.length }}</b-badge>
                    </div>
                    <b-table-simple hover small responsive class="app-table app-table--compact mb-0" v-if="crud.form.ivaDetail.detail && crud.form.ivaDetail.detail.length">
                      <b-thead>
                        <b-tr>
                          <b-th width="25%" class="text-center">Alicuota</b-th>
                          <b-th width="20%" class="text-right">Neto</b-th>
                          <b-th width="20%" class="text-right">IVA</b-th>
                          <b-th width="20%" class="text-right">Total</b-th>
                          <b-th width="15%" class="text-center"></b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody v-for="(item, index) in crud.form.ivaDetail.detail" :key="'iva_' + index">
                        <b-tr>
                          <b-td class="text-center align-middle">
                            <b-badge pill class="crud-purchase-tax-label">
                              <AppIcon name="percent" /> {{item.iva_condition.name}}
                            </b-badge>
                          </b-td>
                          <b-td class="text-right align-middle">
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(item.net)}}
                          </b-td>
                          <b-td class="text-right align-middle">
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(item.iva)}}
                          </b-td>
                          <b-td class="text-right align-middle">
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(parseFloat(item.net) + parseFloat(item.iva))}}
                          </b-td>
                          <b-td class="text-center align-middle">
                            <b-button size="sm"
                                      variant="link"
                                      class="app-table-icon-btn app-table-icon-btn--danger crud-purchase-tax-remove-btn"
                                      v-b-tooltip.hover.left
                                      title="Quitar"
                                      @click="removeItemIVA(index)">
                              <AppIcon name="x" label="Quitar" />
                            </b-button>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                  <EmptyState v-else
                              icon="percent"
                              title="Todavía no agregaste IVA discriminado"
                              description="Cargá una alícuota y el neto gravado para incorporarlo al comprobante." />
                </div>

              </b-tab>

              <b-tab>
                <template #title>
                  <AppIcon name="receipt_long" class="mr-1" /> Percepciones
                  <b-badge pill variant="secondary" class="ml-1">{{ crud.form.percepcionesDetail.detail.length }}</b-badge>
                </template>

                <div class="crud-purchase-tax-guide">
                  <AppIcon name="info-circle" />
                  <span><b>¿Cómo cargar una percepción?</b> Elegí el concepto informado por el proveedor, ingresá el importe retenido y agregalo para que forme parte del total del comprobante.</span>
                </div>

                <div class="crud-purchase-tax-form">
                  <b-row align-v="end">
                    <b-col md="5">
                    <b-form-group label="Percepción">
                      <b-form-select v-model="crud.form.percepcionesDetail.percepciones_id"
                                    :options="arr.select.percepciones"
                                    @change="changePercepciones($event)"
                                    size="sm">
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Importe de la percepción">
                      <b-input-group size="sm" prepend="$">
                        <app-number-input v-model="crud.form.percepcionesDetail.percepcion"
                                          placeholder="Ingrese el total"
                                          @keyup.enter.native="addItemPercepcion()" />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" class="d-flex align-items-end">
                    <b-button size="sm" variant="primary" class="crud-purchase-tax-form__add" @click="addItemPercepcion()">
                      <AppIcon name="plus-circle" class="mr-1" /> Agregar percepción
                    </b-button>
                  </b-col>
                  </b-row>
                </div>

                <div class="crud-purchase-tax-detail">
                  <div v-if="crud.form.percepcionesDetail.detail.length" class="crud-purchase-tax-table">
                    <div class="crud-purchase-tax-table__heading">
                      <span><AppIcon name="receipt_long" /> Percepciones incorporadas</span>
                      <b-badge pill variant="secondary">{{ crud.form.percepcionesDetail.detail.length }}</b-badge>
                    </div>
                    <b-table-simple hover small responsive class="app-table app-table--compact mb-0" v-if="crud.form.percepcionesDetail.detail.length">
                      <b-thead>
                        <b-tr>
                          <b-th width="25%" class="text-center">Percepción</b-th>
                          <b-th width="20%" class="text-right">Total</b-th>
                          <b-th width="15%" class="text-center"></b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody v-for="(item, index) in crud.form.percepcionesDetail.detail" :key="'percepciones_' + index">
                        <b-tr>
                          <b-td class="text-center align-middle">
                            <b-badge pill class="crud-purchase-tax-label" v-if="item.percepciones">
                              <AppIcon name="receipt_long" /> {{item.percepciones.name}}
                            </b-badge>
                          </b-td>
                          <b-td class="text-right align-middle">
                            {{ Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(item.percepcion) }}
                          </b-td>
                          <b-td class="text-center align-middle">
                            <b-button size="sm"
                                      variant="link"
                                      class="app-table-icon-btn app-table-icon-btn--danger crud-purchase-tax-remove-btn"
                                      v-b-tooltip.hover.left
                                      title="Quitar"
                                      @click="removeItemPercepcion(index)">
                              <AppIcon name="x" label="Quitar" />
                            </b-button>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                  <EmptyState v-else
                              icon="receipt_long"
                              title="Todavía no agregaste percepciones"
                              description="Seleccioná el concepto e ingresá su importe para incorporarlo al comprobante." />
                </div>
              </b-tab>
            </b-tabs>

            <div class="crud-purchase-totals crud-purchase-totals--taxes mt-3">
                  <div class="crud-purchase-totals__header">
                    <span><AppIcon name="receipt" /> Resumen del comprobante</span>
                    <span>Importe declarado: <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.crud.form.amount_total)}}</b></span>
                  </div>
                  <div class="crud-purchase-totals__row">
                    <span class="crud-purchase-totals__label">Subtotal</span>
                    <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getSubtotal())}}</span>
                  </div>
                  <div class="crud-purchase-totals__row">
                    <span class="crud-purchase-totals__label">IVA</span>
                    <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getIvaTotal())}}</span>
                  </div>
                  <div class="crud-purchase-totals__row">
                    <span class="crud-purchase-totals__label">Percepciones</span>
                    <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getPercepcionesTotal())}}</span>
                  </div>
                  <div class="crud-purchase-totals__row crud-purchase-totals__row--total">
                    <span class="crud-purchase-totals__label">Importe Final</span>
                    <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getTotal())}}</span>
                  </div>
                  <div class="crud-purchase-totals__row crud-purchase-totals__row--difference"
                       :class="this.getDiffTotal()==0 ? 'crud-purchase-totals__row--balanced' : 'crud-purchase-totals__row--unbalanced'">
                    <span class="crud-purchase-totals__label">
                      <AppIcon :name="this.getDiffTotal()==0 ? 'check-circle' : 'info-circle'" class="mr-1" />
                      <span v-if="this.getDiffTotal()==0">Diferencia (APROBADO)</span>
                      <span v-else-if="this.getDiffTotal()>0">Diferencia (EXCEDIDO)</span>
                      <span v-else>Diferencia (FALTAN)</span>
                    </span>
                    <span class="crud-purchase-totals__value" :class="this.getDiffTotal()==0 ? 'text-success' : 'text-danger'">
                      <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getDiffTotal())}}</b>
                    </span>
                  </div>
            </div>
          </tab-content>

          <tab-content title="Facturas" icon="fa fa-link" :before-change="purchaseValidCrudRelation" v-if="crud.form.types_vouchers && (crud.form.types_vouchers.reference=='notacredito' || crud.form.types_vouchers.reference=='credito-nd')" :key="'tab_c_'+componentKey">
            <b-row>
              <b-col v-if="crud.form.currency">
                <VoucherRelation  :supplier_id="crud.form.suppliers_id"
                                  :point_sale_id="crud.form.points_sales_id"
                                  :details="crud.form.invoiceRelated"
                                  :amount="crud.form.amount_total"
                                  :currency="crud.form.currency"
                                  v-if="crud.form.currency"
                                  @getInvoice="getInvoiceRelated($event)" />
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Conceptos" icon="fa fa-list" :before-change="purchaseValidItemConcepts" v-if="moduleAccountingActive && showConcepts" :key="'tab_d_'+componentKey">
            <b-row class="mb-1" align-h="center" v-for="(element, index) in crud.form.conceptsDetails" :key="index">
              <b-col lg="4">

                  <b-form-input v-model="element.alias"
                                type="text"
                                size="sm"
                                :readonly="true">
                  </b-form-input>

              </b-col>
              <b-col lg="2">

                  <b-input-group size="sm" prepend="$">
                    <app-number-input v-model="crud.form.conceptsDetails[index].amount" placeholder="Ingrese el importe" />
                  </b-input-group>

              </b-col>
            </b-row>
            <b-row align-h="center" class="mt-3">
              <b-col md="6">
                <div class="crud-purchase-totals">
                  <div class="crud-purchase-totals__row crud-purchase-totals__row--total">
                    <span class="crud-purchase-totals__label">Importe Final</span>
                    <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getTotalConcepts())}}</span>
                  </div>
                  <div class="crud-purchase-totals__row">
                    <span class="crud-purchase-totals__label">
                      <span v-if="this.getDiffTotalConcepts()==0">Diferencia (APROBADO)</span>
                      <span v-else-if="this.getDiffTotalConcepts()>0">Diferencia (EXCEDIDO)</span>
                      <span v-else>Diferencia (FALTAN)</span>
                    </span>
                    <span class="crud-purchase-totals__value" :class="this.getDiffTotalConcepts()==0 ? 'text-success' : 'text-danger'">
                      <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getDiffTotalConcepts())}}</b>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Asiento Contable" icon="fa fa-balance-scale" :before-change="purchaseValidItemAccounting" v-if="moduleAccountingActive" :key="'tab_e_'+componentKey">
            <div v-if="contabilidad.render" :key="'accounting_' + itemAccountingForceUpdate">
              <AccountingEntries  :typeDebe="contabilidad.typeDebe"
                                  :typeHaber="contabilidad.typeHaber"
                                  :defaultDebe="contabilidad.defaultDebe"
                                  :defaultHaber="contabilidad.defaultHaber"
                                  :reference="contabilidad.reference"
                                  :amountTotal="contabilidad.amountTotal"
                                  @getAsiento="getAsiento($event)" />
            </div>
          </tab-content>

          <tab-content title="Observaciones" icon="fa fa-flag-checkered" :key="'tab_f_'+componentKey">
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                  ></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>

        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD PAYMENT -->
      <b-modal v-model="modal.payment.active"
              no-close-on-backdrop
              hide-header-close
              size="md">

        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="money" /></span>
          <h5 class="app-modal-header__title">{{this.modal.payment.title}}</h5>
        </div>

        <b-card>
          <b-row>
            <b-col md="12">
              <FinanceSUB @getFinances="storeFinances($event)"
                          v-if="crud.form.suppliers_id && crud.form.points_sales_id"
                          :points_sales="crud.form.points_sales"
                          :amount_impute="crud.form.amount_total"
                          :reset="resetControl"/>
            </b-col>
            <b-col md="12" class="mt-4">
              <b-alert show variant="info" v-if="crud.form.payment && !parseFloat(crud.form.payment.total)">
                Si el <b>comprobante se paga</b> en el momento, cargue el <b>detalle del pago.</b><br><br>
                <i>En caso de no cargar el pago, el comprobante quedará en cuenta corriente <b>pendiente de imputación</b></i>
              </b-alert>
              <div v-else>
                <b-alert show variant="success" v-if="$funciones.compareMoney(crud.form.payment.total, crud.form.amount_total) === 0">
                  Comprobante Saldado
                </b-alert>
                <div v-else>
                  <b-alert show variant="warning" v-if="$funciones.compareMoney(crud.form.payment.total, crud.form.amount_total) > 0">
                    El importe pagado es mayor al total del comprobante.<br>
                    <b>Importe Comprobante</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.amount_total)}}<br>
                    <b>Importe Pagado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.payment.total)}}<br><br>
                    <i>El saldo quedará en cuenta corriente pendiente de imputación a favor de la empresa</i>
                  </b-alert>
                  <b-alert show variant="danger" v-if="$funciones.compareMoney(crud.form.payment.total, crud.form.amount_total) < 0">
                    El importe pagado es menor al total del comprobante.<br>
                    <b>Importe Comprobante</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.amount_total)}}<br>
                    <b>Importe Pagado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.payment.total)}}<br><br>
                    <i>El comprobante quedará en cuenta corriente pendiente de imputación</i>
                  </b-alert>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancelPayment()">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Finalizar</b-button>
        </div>
      </b-modal>

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              size="xl"
              :key="modal.detail._id"
              :id="modal.detail._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">{{this.modal.detail.title}}</h5>
        </div>

        <b-row>
          <b-col sm="12">
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab>
                <template #title><AppIcon name="description" class="mr-1" /> General</template>
                <div class="app-modal-detail-list" v-if="itemSelected">
                  <b-alert v-if="getPurchaseRemitsDifference(itemSelected)" show variant="info" class="mb-3">
                    <AppIcon name="info-circle" class="mr-1" />
                    <b>Mensaje informativo:</b> el importe neto de la factura ({{ formatPurchaseRemitAmount(getPurchaseRemitsDifference(itemSelected).invoiceAmount, itemSelected) }}) difiere del importe neto de los ítems de remito vinculados ({{ formatPurchaseRemitAmount(getPurchaseRemitsDifference(itemSelected).remitAmount, itemSelected) }}).
                  </b-alert>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">ID</span>
                    <span class="app-modal-detail-list__value"><b>#{{this.itemSelected.id}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Empresa</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.points_sales.business.reference}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.purchase_category">
                    <span class="app-modal-detail-list__label">Categoria</span>
                    <span class="app-modal-detail-list__value">
                      <b-badge variant="secondary">{{this.itemSelected.purchase_category.name}}</b-badge>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.points_sales">
                    <span class="app-modal-detail-list__label">Punto de Venta Imputación</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.points_sales.point_sale}} - {{this.itemSelected.points_sales.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.type_voucher && itemSelected.number">
                    <span class="app-modal-detail-list__label">Comprobante</span>
                    <span class="app-modal-detail-list__value"><b>{{this.itemSelected.type_voucher.name + ' '  + this.itemSelected.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.number.toString().padStart(8,'0')}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.staff">
                    <span class="app-modal-detail-list__label">Emisor</span>
                    <span class="app-modal-detail-list__value">{{itemSelected.staff.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha Vencimiento</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date_expiration).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha Imputación</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date_imputation).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.supplier">
                    <span class="app-modal-detail-list__label">Proveedor</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.supplier.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.info_payment">
                    <span class="app-modal-detail-list__label">Forma de Pago</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.info_payment.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">Neto Gravado</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_net)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">Neto No Gravado</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_not_taxed)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">IVA</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_iva)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">Percepciones</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_perceptions)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">Total</span>
                    <span class="app-modal-detail-list__value"><b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_total)}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.amount_impute!=itemSelected.amount_total">
                    <span class="app-modal-detail-list__label">Pendiente de Imputación</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning"><b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(getPendingVoucherPurchase(this.itemSelected))}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row crud-purchase-detail-observations-row" v-if="itemSelected.observations">
                    <span class="app-modal-detail-list__label">Observaciones</span>
                    <span class="app-modal-detail-list__value crud-purchase-observations-content">{{this.itemSelected.observations}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.file">
                    <span class="app-modal-detail-list__label">Documento</span>
                    <span class="app-modal-detail-list__value">
                      <b-link :href="itemSelected.file" target="blank"><b>Ver Archivo</b></b-link>
                    </span>
                  </div>
                </div>
              </b-tab>

              <b-tab v-if="itemSelected && itemSelected.type_voucher && itemSelected.type_voucher.code_afip">
                <template #title><AppIcon name="percent" class="mr-1" /> Impuestos</template>
                <b-row>
                  <b-col>
                    <b-table class="mb-0 app-table app-table--compact"
                            responsive
                            :stacked="isMobileViewport ? 'md' : false"
                            :hover="true"
                            :small="true"
                            :fixed="true"
                            :items="tableSubIva.items"
                            :fields="tableSubIva.fields"
                            v-if="tableSubIva.items.length">

                      <template v-slot:table-colgroup="scope">
                        <col
                          v-for="field in scope.fields"
                          :key="field.key"
                          :style="{ width: field.width }"
                        >
                      </template>

                      <template v-slot:cell(iva_condition)="data">
                        {{data.item.iva_condition.name}}
                      </template>

                      <template v-slot:cell(amount_net)="data">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_net)}}
                      </template>

                      <template v-slot:cell(amount_iva)="data">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_iva)}}
                      </template>

                      <template v-slot:cell(amount_total)="data">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_total)}}
                      </template>
                    </b-table>
                    <EmptyState v-else icon="percent" title="Sin discriminación de IVA" />
                  </b-col>
                  <b-col>
                    <b-table class="mb-0 app-table app-table--compact"
                            responsive
                            :stacked="isMobileViewport ? 'md' : false"
                            :hover="true"
                            :small="true"
                            :fixed="true"
                            :items="tableSubPercepcion.items"
                            :fields="tableSubPercepcion.fields"
                            v-if="tableSubPercepcion.items.length">

                      <template v-slot:table-colgroup="scope">
                        <col
                          v-for="field in scope.fields"
                          :key="field.key"
                          :style="{ width: field.width }"
                        >
                      </template>

                      <template v-slot:cell(percepcion)="data">
                        {{data.item.perception.name}}
                      </template>

                      <template v-slot:cell(amount_total)="data">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_total)}}
                      </template>
                    </b-table>
                    <EmptyState v-else icon="receipt_long" title="Sin discriminación de Percepciones" />
                  </b-col>
                </b-row>
              </b-tab>

              <b-tab v-if="tableImputation.items.length">
                <template #title><AppIcon name="link" class="mr-1" /> Imputaciones</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableImputation.items"
                        :fields="tableImputation.fields">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(date)="data">
                    {{moment(data.item.date).format('DD/MM/YYYY')}}
                  </template>

                  <template v-slot:cell(reference)="data">
                    {{data.item.reference}}
                  </template>

                  <template v-slot:cell(amount_total)="data">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.amount_total)}}
                  </template>
                </b-table>
              </b-tab>

              <b-tab v-if="tableRemits.items.length">
                <template #title><AppIcon name="truck" class="mr-1" /> Remitos</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableRemits.items"
                        :fields="tableRemits.fields"
                        v-if="tableRemits.items.length">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(date)="data">
                    {{moment(data.item.remit.date).format('DD/MM/YYYY')}}
                  </template>

                  <template v-slot:cell(remits)="data">
                    <div v-if="data.item.remit.type_voucher">
                      {{data.item.remit.type_voucher.name + ' '  + data.item.remit.point_sale.toString().padStart(4,'0') + '-' + data.item.remit.number.toString().padStart(8,'0')}}
                    </div>
                  </template>

                  <template v-slot:cell(code)="data">
                    <div v-html="getProductCode(data.item)"></div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div v-html="getProductName(data.item)"></div>
                  </template>

                  <template v-slot:cell(quantity)="data">
                    {{data.item.quantity}}
                    <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                  </template>

                  <template v-slot:cell(price)="data">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(data.item.price_cost)}}
                  </template>

                  <template v-slot:cell(total)="data">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(parseFloat(data.item.price_cost) * parseFloat(data.item.quantity))}}
                  </template>

                  <template v-slot:cell(action)="data">
                    <b-button size="sm"
                              variant="link"
                              class="app-table-icon-btn app-table-icon-btn--danger"
                              :class="{ 'app-table-icon-btn--labeled': isMobileViewport }"
                              v-b-tooltip.hover.left
                              title="Desvincular"
                              @click="unlinkRemitsDetail(data.item)">
                      <AppIcon name="link_off" label="Desvincular" />
                      <span v-if="isMobileViewport" class="ml-1">Desvincular</span>
                    </b-button>
                  </template>
                </b-table>
                <EmptyState v-else icon="truck" title="No se encontraron registros" />
              </b-tab>

              <b-tab v-if="moduleAccountingActive">
                <template #title><AppIcon name="bar-chart" class="mr-1" /> Asiento</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableAccounting.items"
                        :fields="tableAccounting.fields"
                        v-if="tableAccounting.items.length">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(code)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_code}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_code}}</span>
                    </div>
                  </template>

                  <template v-slot:cell(name)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_name}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_name}}</span>
                    </div>
                  </template>

                  <template v-slot:cell(debit)="data">
                    <b v-if="data.item.type == 'Debe'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </b>
                  </template>

                  <template v-slot:cell(credit)="data">
                    <b v-if="data.item.type == 'Haber'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </b>
                  </template>
                </b-table>
                <EmptyState v-else icon="bar-chart" title="No se encontraron registros" />
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

      <!-- FILE -->
      <b-modal v-model="modal.formFile.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close>
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="paperclip" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formFile.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <div class="crud-purchase-title" v-if="itemSelected">
              <div class="crud-purchase-title">
                <span v-if="itemSelected.type_voucher && itemSelected.number" class="crud-purchase-code">
                  {{this.itemSelected.type_voucher.name + ' '  + this.itemSelected.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.number.toString().padStart(8,'0')}}
                </span><br>
                <span v-if="itemSelected.supplier">
                  {{this.itemSelected.supplier.name}}
                </span>
              </div>
            </div>
          </b-col>
          <b-col>
            <br>
          </b-col>
          <b-col md="12">
            <b-form-group label="Documento">
              <b-form-file v-if="!crud.formFile.fileLink"
                           v-model="crud.formFile.file"
                           size="sm"
                           :state="Boolean(crud.formFile.file)"
                           placeholder="Elija un archivo o sueltelo aquí..."
                           drop-placeholder="Suelta el archivo aquí...">
              </b-form-file>
              <div v-else>
                <b-link :href="crud.formFile.fileLink" target="_blank">
                  <b>Ver Archivo</b>
                </b-link>
                <b-button type="button" variant="outline-dark" size="sm" class="btn-pill ml-2" @click="crud.formFile.fileLink=''" v-b-tooltip.hover title="Cargar otro archivo">
                  <AppIcon name="refresh" />
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formFile.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveFile()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- EDICIÓN RÁPIDA -->
      <b-modal v-model="modal.formExtra.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="lg">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formExtra.title}}</h5>
        </div>

        <div class="crud-purchase-quick-edit">
          <div class="crud-purchase-quick-edit__identity">
            <div class="crud-purchase-title" v-if="itemSelected">
              <div class="crud-purchase-title">
                <span v-if="itemSelected.type_voucher && itemSelected.number" class="crud-purchase-code">
                  {{this.itemSelected.type_voucher.name + ' '  + this.itemSelected.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.number.toString().padStart(8,'0')}}
                </span><br>
                <span v-if="itemSelected.supplier">
                  {{this.itemSelected.supplier.name}}
                </span>
              </div>
            </div>
          </div>
          <b-row class="crud-purchase-quick-edit__dates">
            <b-col md="4">
              <b-form-group label="Fecha">
                <b-form-datepicker size="sm" v-model="crud.formExtra.date" placeholder="Fecha" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha Vencimiento">
                <b-form-datepicker size="sm" v-model="crud.formExtra.date_expiration" placeholder="Fecha Vencimiento" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha Imputación">
                <b-form-datepicker size="sm" v-model="crud.formExtra.date_imputation" placeholder="Fecha Imputación" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="crud-purchase-quick-edit__details">
            <b-col md="6" v-if="canShowPurchaseCategory">
              <FindObject type="purchaseCategory"
                          render="search"
                          @select-object="loadPurchaseCategoryExtra($event)"
                          :valueID="crud.formExtra.purchase_category_id"/>
            </b-col>
            <b-col md="6" v-if="canShowPurchaseInfoPayment">
              <FindObject type="purchaseInfoPayment"
                          render="search"
                          @select-object="loadInfoPaymentExtra($event)"
                          :valueID="crud.formExtra.info_payment_id"/>
            </b-col>
            <b-col md="12">
              <b-form-group label="Observaciones">
                <app-textarea v-model="crud.formExtra.observations"
                              placeholder="Ingresar las observaciones..."
                              rows="3"
                              max-rows="6"></app-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formExtra.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveExtra()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- REMITS -->
      <b-modal v-model="modal.formRemits.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              :key="modal.formRemits._id"
              :id="modal.formRemits._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="truck" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formRemits.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <div class="crud-purchase-title" v-if="itemSelected">
              <div class="crud-purchase-title">
                <span v-if="itemSelected.type_voucher && itemSelected.number" class="crud-purchase-code">
                  {{this.itemSelected.type_voucher.name + ' '  + this.itemSelected.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.number.toString().padStart(8,'0')}}
                </span><br>
                <span v-if="itemSelected.supplier">
                  {{this.itemSelected.supplier.name}}
                </span>
              </div>
            </div>
          </b-col>
          <b-col>
            <br>
          </b-col>
          <b-col md="12">
            <b-table-simple hover small caption-top responsive v-if="itemSelectedRemit && itemSelectedRemit.length" class="app-table app-table--compact app-table--stacked-manual crud-remit-table-items">
              <b-thead>
                <b-tr>
                  <b-th width="10%" class="text-left">Fecha</b-th>
                  <b-th width="20%" class="text-left">Remito</b-th>
                  <b-th width="10%" class="text-left">Código</b-th>
                  <b-th width="30%" class="text-left">Descripción</b-th>
                  <b-th width="10%" class="text-right">Cantidad</b-th>
                  <b-th width="10%" class="text-right">Precio</b-th>
                  <b-th width="10%" class="text-center">Vincular</b-th>
                </b-tr>
              </b-thead>
              <b-tbody v-for="item in itemSelectedRemit" :key="item.id">
                <b-tr v-if="item.remit ">
                  <b-td data-label="Fecha" :class="'align-middle ' + alignClass('text-left')">
                    {{moment(item.remit.date).format('DD/MM/YYYY')}}
                  </b-td>
                  <b-td data-label="Remito" :class="'align-middle ' + alignClass('text-left')">
                    <div v-if="item.remit.type_voucher">
                      {{item.remit.type_voucher.name + ' '  + item.remit.point_sale.toString().padStart(4,'0') + '-' + item.remit.number.toString().padStart(8,'0')}}
                    </div>
                  </b-td>
                  <b-td data-label="Código" :class="'align-middle ' + alignClass('text-left')">
                    <div v-html="getProductCode(item)"></div>
                  </b-td>
                  <b-td data-label="Descripción" :class="'align-middle ' + alignClass('text-left')">
                    <div v-html="getProductName(item)"></div>
                  </b-td>
                  <b-td data-label="Cantidad" :class="'align-middle ' + alignClass('text-right')">
                    {{item.quantity}}
                    <span v-if="item.unit_measurement">{{item.unit_measurement.reference}}</span>
                  </b-td>
                  <b-td data-label="Precio" :class="'align-middle ' + alignClass('text-right')">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(item.price_cost)}}
                  </b-td>
                  <b-td data-label="Vincular" :class="'align-middle ' + alignClass('text-center')">
                    <b-form-checkbox v-model="item.check"
                                      @click="getSummaryRemits()"
                                      switch
                                      size="sm"
                                      class="pull-center">
                    </b-form-checkbox>
                  </b-td>
                </b-tr>
              </b-tbody>
              <b-tfoot>
                <b-tr>
                  <b-td colspan="7" variant="secondary" class="text-right">
                    Total: <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getSummaryRemits())}}</b>
                  </b-td>
                </b-tr>
              </b-tfoot>
            </b-table-simple>
            <EmptyState v-else icon="truck" title="No hay items de remitos para asociar" />

          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formRemits.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveRemits()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import FindObject from '@/components/inc/find/findObject'
  import AccountingEntries from '@/components/inc/accounting/entries'
  import VoucherRelation from './inc/detailInvoice'
  import VoucherExpiration from './inc/VoucherExpiration'
  import FinanceSUB from '@/components/inc/finances/sub'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  export default {
    components: {
      FindObject,
      FormWizard,
      TabContent,
      AccountingEntries,
      VoucherRelation,
      VoucherExpiration,
      FinanceSUB,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
            module_id: Modules.COMPRAS,
            profile_id: Profiles.PERSONAL,
            view_reference: 'purchase',
            elements: {
              deletePurchase: true
            }
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        tableSubIva : {
          items: [],
          fields: []
        },
        tableSubPercepcion : {
          items: [],
          fields: []
        },
        tableSubRemits: {
          items: [],
          fields: []
        },
        tableAccounting : {
          items: [],
          fields: []
        },
        tableImputation : {
          items: [],
          fields: []
        },
        tableRemits : {
          items: [],
          fields: []
        },
        crud: {
          form: {
            id: 0,
            date: '',
            date_expiration: '',
            date_imputation: '',
            types_vouchers_id: 0,
            types_vouchers: null,
            letter: '',
            point_sale: 0,
            number: 0,
            observations: '',
            staff_id: 0,
            suppliers_id: 0,
            suppliers: null,
            currency_id: 0,
            currency: null,
            remits_id: 0,
            remits: null,
            points_sales_id: 0,
            points_sales: null,
            detail: [],
            ivaDetail: {
              net: 0,
              iva: 0,
              iva_condition_id: 0,
              iva_condition: null,
              detail: [],
            },
            percepcionesDetail: {
              percepcion: 0,
              percepciones_id: 0,
              percepciones: null,
              detail: [],
            },
            conceptsDetails: [],
            invoiceRelated: [],
            accountingEntry: null,
            amount_total: 0,
            purchase_category_id: 0,
            purchase_category: null,
            info_payment_id: 0,
            info_payment: null,
            payment: [],
            showPayment: true,
          },
          formFile: {
            id: 0,
            fileLink: '',
            file: null,
          },
          formExtra: {
            id: 0,
            date: '',
            date_expiration: '',
            date_imputation: '',
            purchase_category_id: 0,
            purchase_category: null,
            info_payment_id: 0,
            info_payment: null,
            observations: '',
          },
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          payment: {
            active: false,
            title: '',
          },
          formFile: {
            active: false,
            title: '',
          },
          formRemits: {
            active: false,
            title: '',
          },
          detail: {
            active: false,
            title: ''
          },
          formExtra: {
            active: false,
            title: '',
          },
        },
        arr: {
          purchase: [],
          typeVouchers: [],
          ivaCondition: [],
          percepciones: [],
          export: [],
          select: {
            typeVouchers: [],
            ivaCondition: [],
            percepciones: [],
          },
          filters : {
            suppliers: [],
            categories: [],
            expirationStatus: [
              { value: '', text: 'Todos' },
              { value: 'overdue', text: 'Vencidas' },
              { value: 'next_7', text: 'Próximos 7 días' },
              { value: 'next_15', text: 'Próximos 15 días' },
              { value: 'next_30', text: 'Próximos 30 días' },
            ],
          }
        },
        filters: {
          date_start: '',
          date_end: '',
          suppliers: null,
          categories: null,
          expiration_status: '',
        },
        itemSelected: null,
        itemSelectedRemit: null,
        detailDrawer: false,
        // Panel de filtros: cerrado por default; el usuario que lo abre queda
        // con su preferencia persistida (ver watcher filtersOpen).
        filtersOpen: false,
        // stacked (modo card mobile) y sticky-header son mutuamente
        // excluyentes en BootstrapVue — stacked solo se activa cuando el
        // viewport realmente está en mobile (ver mounted/mobileMql).
        isMobileViewport: false,
        itemAccountingForceUpdate: 0,
        invoiceFromRemitsActive: false,
        purchaseGenerationOrigin: null,
        voucherRequestKey: 0,
        pendingVoucherNameDefault: null,
        pendingVoucherNamePrefixDefault: null,
        contabilidad: {
          render: false,
          typeDebe:"",
          typeHaber:"",
          defaultDebe:[],
          defaultHaber:[],
          reference:'',
          amountTotal:0
        },
        componentKey: 0,
        componentKeyAlt: 0,
        resetControl: false,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.deletePurchase = Helper.hasAccessElement(this.access, 'delete_purchase')
      /* Fin configuracion */
    },
    computed: {
      conditionCurrencyActive() {
        return [{field: 'status', condition: true}]
      },
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentPurchaseIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrevPurchase() {
        return this.currentPurchaseIndex > 0
      },
      canGoNextPurchase() {
        if(this.currentPurchaseIndex < 0) {
          return false
        }
        return this.currentPurchaseIndex < (this.table.items.length - 1)
      },

      // CONDITIONS SELECT
      conditionSuppliersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPointsSalesActive() {
        return [{field: 'active', condition: true}];
      },
      canShowPurchaseCategory() {
        return Helper.showAccessView(this.access, 'purchaseCategory')
      },
      canShowPurchaseInfoPayment() {
        return Helper.showAccessView(this.access, 'infoPayment')
      },

      // MODULES
      modulePaymentsActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.PAGOS_ERP) {
            status = true
          }
        })
        return status
      },
      moduleAccountingActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {
            status = true
          }
        })
        return status
      },

      // CURRENCY
      getCurrency() {
        if(this.crud.form.currency) {
          return this.crud.form.currency.code
        } else {
          return 'ARS'
        }
      },

      // VOUCHER
      getRefVoucher() {
        if(this.crud.form.types_vouchers && this.crud.form.number) {
          return this.crud.form.types_vouchers.name + ' '  + this.crud.form.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.number.toString().padStart(8,'0')
        } else {
          return ''
        }
      },

      // CONFIGURACION
      showConcepts() {
        var show = false
        if(this.crud.form.suppliers) {
          if(this.crud.form.suppliers.accounting_account) {
            if(this.crud.form.suppliers.accounting_account.concepts) {
              show = true
            }
          }
        }
        return show
      },

      getRemitReference() {
        if(this.crud.form.remits && this.crud.form.remits.type_voucher && this.crud.form.remits.point_sale && this.crud.form.remits.number) {
          return this.crud.form.remits.type_voucher.name + ' ' + this.crud.form.remits.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.remits.number.toString().padStart(8,'0')
        } else {
          return 'ID #' + this.crud.form.remits_id
        }
      },
    },
    mounted() {
      this.loadFieldTable()
      this.filterLoad()
      this.filterPurchase()
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_purchase') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.crud.form.remits_id = this.$route.params.remitsID
      if(this.crud.form.remits_id) {
        this.purchaseGenerationOrigin = 'remits'
        this.invoiceFromRemits()
        // Vuelve a la ruta simple apenas se consume el param -- si no, la
        // pestaña queda con el remito pegado en la URL para siempre y
        // volver a ella (activated, keep-alive) generaría la compra de
        // nuevo aunque el usuario solo quiera ver el listado.
        this.$router.replace({ name: 'PurchaseStaffPurchase' }).catch(() => {})
      }

      // Acción directa desde la paleta de comandos: abrir el alta al entrar.
      if (this.$route.query.new == '1') {
        this.add()
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.filterLoad()
      this.filterPurchase()

      this.crud.form.remits_id = this.$route.params.remitsID
      if(this.crud.form.remits_id) {
        this.purchaseGenerationOrigin = 'remits'
        this.invoiceFromRemits()
        this.$router.replace({ name: 'PurchaseStaffPurchase' }).catch(() => {})
      }

      // Misma acción directa que en mounted(): si la pestaña ya estaba
      // montada (keep-alive), "mounted" no vuelve a correr y la paleta de
      // comandos no abriría nada sin este chequeo acá también.
      if (this.$route.query.new == '1') {
        this.add()
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }
    },
    watch: {
      '$route.params.remitsID': function (newVal, oldVal) {
        if(newVal && newVal != oldVal) {
          this.crud.form.remits_id = parseInt(newVal)
          if(this.crud.form.remits_id) {
            this.purchaseGenerationOrigin = 'remits'
            this.invoiceFromRemits()
            this.$router.replace({ name: 'PurchaseStaffPurchase' }).catch(() => {})
          }
        }
      },
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_purchase', value ? 'true' : 'false')
      },
      // Si el viewport cruza el breakpoint mobile (resize/rotación), las
      // clases de alineación y la visibilidad del kebab tienen que recalcularse.
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      // Alineación de columna: en mobile (modo stacked) el valor pasa a
      // apilarse debajo de su label, así que la alineación de columna de
      // desktop (centrado/derecha) no tiene sentido acá.
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      // Confirm estándar: header con ícono + tinte suave (.app-confirm-header)
      // en vez de header-bg-variant sólido, size 'sm' siempre, y
      // okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el dropdown de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      // Resalta en la tabla la fila del registro que está abierto en el
      // drawer, para no perder la referencia visual mientras se navega con
      // los botones anterior/siguiente.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      isPendingPurchase(item) {
        return !!item && !!item.type_voucher && item.type_voucher.type_balance == '+' &&
          Number(item.amount_total || 0) > Number(item.amount_impute || 0)
      },
      forceRender() {
        this.componentKey += 1;
      },
      forceRenderAlt() {
        this.componentKeyAlt += 1;
      },

      /****************
       * RETORNO *
       * **************/
      isGenerateFromRemitsRoute() {
        return this.purchaseGenerationOrigin == 'remits' || (this.$route.name == 'PurchaseStaffPurchaseGenerateByRemits' && !!this.$route.params.remitsID)
      },
      returnToPurchaseRemits() {
        if (!this.isGenerateFromRemitsRoute()) return
        this.purchaseGenerationOrigin = null
        this.goPurchaseRemits()
      },
      goPurchaseRemits() {
        this.$router.push({ name: 'PurchaseStaffPurchaseRemits' }, () => {
          window.__suppressBeforeUnload = true
          window.location.reload()
        })
      },
      // PROCESS ADMINISTRATIVE
      invoiceFromRemits() {
        if(this.invoiceFromRemitsActive) {
          return false
        }
        this.invoiceFromRemitsActive = true

        let remitsID = this.crud.form.remits_id
        let loader = this.$loading.show();

        serviceAPI.mostrarRemito(remitsID)
        .then((response) => {
          var remit = response.data

          if(!remit) {
            loader.hide()
            this.$awn.alert("No se encontró el remito");
            this.goPurchaseRemits()
            this.invoiceFromRemitsActive = false
            return false
          }

          if(remit.purchase_id || remit.purchase) {
            loader.hide()
            this.$awn.alert("El remito ya se encuentra facturado");
            this.goPurchaseRemits()
            this.invoiceFromRemitsActive = false
            return false
          }

          this.resetFormFields()
          this.applyRemitPreset(remit)
          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.active = true
          this.modal.form.title = 'Comprobante de Proveedor'
          this.invoiceFromRemitsActive = false

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.crud.form.remits_id = 0
          this.invoiceFromRemitsActive = false
          this.$awn.alert(Error.showError(error));
        })
      },
      applyRemitPreset(remit) {
        this.crud.form.date = moment(remit.date).format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment(remit.date).format('YYYY-MM-DD')
        this.crud.form.date_imputation = moment(remit.date).format('YYYY-MM-DD')

        if(remit.supplier) {
          this.crud.form.suppliers = remit.supplier
          this.crud.form.suppliers_id = remit.supplier.id
        }

        if(remit.points_sales) {
          this.crud.form.points_sales = remit.points_sales
          this.crud.form.points_sales_id = remit.points_sales.id
        }

        // Punto de venta "No Informado" (nd=true, no se reporta a ARCA) => el comprobante
        // se predefine como Gasto ND; en cualquier otro caso, la primera "Factura A/B/C"
        // que aparezca entre los tipos disponibles para ese proveedor+punto de venta (no
        // siempre está la A — depende de la condición fiscal del proveedor).
        // Se guarda acá porque loadTypeVouchersBySuppliers() recién trae la lista de
        // comprobantes disponibles después (la dispara el FindObject de proveedor/punto de
        // venta al reaccionar a estos mismos campos, de forma asincrónica).
        if(remit.points_sales && remit.points_sales.nd) {
          this.pendingVoucherNameDefault = 'GASTO ND'
          this.pendingVoucherNamePrefixDefault = null
        } else {
          this.pendingVoucherNameDefault = null
          this.pendingVoucherNamePrefixDefault = 'FACTURA'
        }

        if(remit.point_sale !== undefined && remit.point_sale !== null) {
          this.crud.form.point_sale = remit.point_sale
        }

        if(remit.number !== undefined && remit.number !== null) {
          this.crud.form.number = remit.number
        }

        this.crud.form.remits_id = remit.id
        this.crud.form.remits = remit

        const estimatedTotal = this.getRemitAmountTotal(remit)
        if(estimatedTotal > 0) {
          this.crud.form.amount_total = estimatedTotal
        }

        this.forceRender()
        this.forceRenderAlt()

        const remitVoucher = (remit.type_voucher && remit.point_sale)
          ? remit.type_voucher.name + ' ' + remit.point_sale.toString().padStart(4,'0') + '-' + remit.number.toString().padStart(8,'0')
          : 'ID #' + remit.id
        this.crud.form.observations = 'Remito: ' + remitVoucher
      },
      getRemitAmountTotal(remit) {
        var total = 0
        const addItem = (element) => {
          var net = parseFloat(element.quantity) * parseFloat(element.price_cost || 0)
          if(!isNaN(net)) {
            var aliquot = (element.iva_condition && element.iva_condition.aliquot)
              ? parseFloat(element.iva_condition.aliquot)
              : 0
            total += net * (1 + aliquot / 100)
          }
        }
        if(remit.details && remit.details.products) {
          remit.details.products.forEach(addItem)
        }
        if(remit.details && remit.details.products_compound) {
          remit.details.products_compound.forEach(addItem)
        }
        return parseFloat(total.toFixed(2))
      },
      getPurchaseRemitsTotal(purchase) {
        return (purchase && purchase.purchase_remits_detail ? purchase.purchase_remits_detail : [])
          .reduce((total, detail) => total + (parseFloat(detail.quantity) * parseFloat(detail.price_cost || 0) || 0), 0)
      },
      getPurchaseRemitsDifference(purchase) {
        // Sólo las facturas A conservan el neto discriminado. En los restantes
        // comprobantes amount_net incluye el IVA, mientras que price_cost del
        // remito es neto; compararlos produciría una diferencia falsa.
        if(!purchase || purchase.letter != 'A' || !purchase.purchase_remits_detail || !purchase.purchase_remits_detail.length) {
          return null
        }
        const remitAmount = this.getPurchaseRemitsTotal(purchase)
        const invoiceAmount = parseFloat(purchase.amount_net) || 0
        if(Math.abs(invoiceAmount - remitAmount) <= 0.009) {
          return null
        }
        return { invoiceAmount, remitAmount }
      },
      formatPurchaseRemitAmount(amount, purchase) {
        const currency = purchase && purchase.currency && purchase.currency.code ? purchase.currency.code : this.getCurrency
        return Intl.NumberFormat('es-AR', { style: 'currency', currency: currency || 'ARS' }).format(amount)
      },

      // CONFIGURACION
      loadFieldTable () {
        // TABLE COMPROBANTES
        this.table.fields = []
        this.table.fields.push({key: 'business', label: 'Empresa', class:"align-middle " + this.alignClass('text-left'), width:"60px"})
        this.table.fields.push({key: 'voucher', label: 'Comprobante', class:"align-middle " + this.alignClass('text-left'), width:"150px"})
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-center'), width:"90px"})
        this.table.fields.push({key: 'date_expiration', label: 'Vencimiento', class:"align-middle " + this.alignClass('text-center'), width:"110px"})
        this.table.fields.push({key: 'suppliers_id', label: 'Proveedor', class:"align-middle", width:"150px"})
        this.table.fields.push({key: 'info_payment', label: this.isMobileViewport ? 'Forma de Pago' : '', class:"align-middle " + this.alignClass('text-center'), width:"10px"})
        this.table.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"80px"})
        this.table.fields.push({key: 'amount_pending', label: 'Pendiente', class:"align-middle " + this.alignClass('text-right'), width:"80px"})
        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        // Excepción al estándar: esta vista SÍ conserva el kebab en mobile
        // (link "Opciones", no ícono-only) — ver cell(f_action) y la clase
        // .crud-purchase-action-toggle-labeled.
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"60px"})

        // TABLE DETALLE
        this.tableSubIva.fields = []
        this.tableSubIva.fields.push({key: 'iva_condition', label: 'IVA', class:"align-middle " + this.alignClass('text-left'), width:"25%"})
        this.tableSubIva.fields.push({key: 'amount_net', label: 'Neto', class:"align-middle " + this.alignClass('text-right'), width:"25%"})
        this.tableSubIva.fields.push({key: 'amount_iva', label: 'IVA', class:"align-middle " + this.alignClass('text-right'), width:"25%"})
        this.tableSubIva.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"25%"})

        // TABLE PERCEPCIONES
        this.tableSubPercepcion.fields = []
        this.tableSubPercepcion.fields.push({key: 'percepcion', label: 'Percepción', class:"align-middle " + this.alignClass('text-left'), width:"75%"})
        this.tableSubPercepcion.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"25%"})

        // TABLE REMITOS (resumen del drawer)
        this.tableSubRemits.fields = []
        this.tableSubRemits.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-left'), width:"25%"})
        this.tableSubRemits.fields.push({key: 'remits', label: 'Remito', class:"align-middle " + this.alignClass('text-left'), width:"75%"})

        // TABLE ASIENTO
        this.tableAccounting.fields = []
        this.tableAccounting.fields.push({key: 'code', label: 'Código', class:"align-middle " + this.alignClass('text-left'), width:"20%"})
        this.tableAccounting.fields.push({key: 'name', label: 'Nombre', class:"align-middle " + this.alignClass('text-left'), width:"40%"})
        this.tableAccounting.fields.push({key: 'debit', label: 'Debe', class:"align-middle " + this.alignClass('text-right'), width:"20%"})
        this.tableAccounting.fields.push({key: 'credit', label: 'Haber', class:"align-middle " + this.alignClass('text-right'), width:"20%"})

        // TABLE IMPUTACIONES
        this.tableImputation.fields = []
        this.tableImputation.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-left'), width:"20%"})
        this.tableImputation.fields.push({key: 'reference', label: 'Referencia', class:"align-middle " + this.alignClass('text-left'), width:"50%"})
        this.tableImputation.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"30%"})

        // TABLE REMITOS (detalle completo)
        this.tableRemits.fields = []
        this.tableRemits.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-left'), width:"10%"})
        this.tableRemits.fields.push({key: 'remits', label: 'Remito', class:"align-middle " + this.alignClass('text-left'), width:"15%"})
        this.tableRemits.fields.push({key: 'code', label: 'Código', class:"align-middle " + this.alignClass('text-left'), width:"10%"})
        this.tableRemits.fields.push({key: 'description', label: 'Descripción', class:"align-middle " + this.alignClass('text-left'), width:"25%"})
        this.tableRemits.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-right'), width:"10%"})
        this.tableRemits.fields.push({key: 'price', label: 'Precio', class:"align-middle " + this.alignClass('text-right'), width:"10%"})
        this.tableRemits.fields.push({key: 'total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"10%"})
        this.tableRemits.fields.push({key: 'action', label: this.isMobileViewport ? 'Acciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"10%"})
      },

      // EXPORT
      prepareExport(data) {
        this.arr.export = []
        data.forEach(element => {
          var businessID = 0
          var businessName = ""
          var suppliersID = 0
          var suppliersCode = ""
          var suppliersName = ""
          var currencyID = 0
          var currencyName = ""
          var typeVoucherID = 0
          var typeVoucherName = ""
          var pointSalesID = 0
          var pointSalesName = ""
          var purchaseCategoryID = 0
          var purchaseCategoryName = ""
          var infoPaymentID = 0
          var infoPaymentName = ""

          if(element.points_sales && element.points_sales.business) {
            businessID = element.points_sales.business.id
            businessName = element.points_sales.business.reference
          }
          if(element.supplier) {
            suppliersID = element.supplier.id
            suppliersCode = element.supplier.code
            suppliersName = element.supplier.name
          }

          if(element.currency) {
            currencyID = element.currency.id
            currencyName = element.currency.name
          }

          if(element.type_voucher) {
            typeVoucherID = element.type_voucher.id
            typeVoucherName = element.type_voucher.name
          }

          if(element.points_sales) {
            pointSalesID = element.points_sales.id
            pointSalesName = element.points_sales.name
          }

          if(element.purchase_category) {
            purchaseCategoryID = element.purchase_category.id
            purchaseCategoryName = element.purchase_category.name
          }

          if(element.info_payment) {
            infoPaymentID = element.info_payment.id
            infoPaymentName = element.info_payment.name
          }

          this.arr.export.push({
            id: element.id,
            businessID: businessID,
            businessName: businessName,
            date: element.date,
            date_expiration: element.date_expiration,
            date_imputation: element.date_imputation,
            typeVoucherID: typeVoucherID,
            typeVoucherName: typeVoucherName,
            letter: element.letter,
            point_sale: element.point_sale,
            number: element.number,
            suppliersID: suppliersID,
            suppliersCode: suppliersCode,
            suppliersName: suppliersName,
            currencyID: currencyID,
            currencyName: currencyName,
            amount_iva: element.amount_iva.replace('.',','),
            amount_net: element.amount_net.replace('.',','),
            amount_not_taxed: element.amount_not_taxed.replace('.',','),
            amount_perceptions: element.amount_perceptions.replace('.',','),
            amount_total: element.amount_total.replace('.',','),
            amount_pending: element.type_voucher && element.type_voucher.type_balance == '+' && element.amount_total != element.amount_impute
              ? this.getPendingVoucherPurchase(element).toString().replace('.', ',')
              : '',
            observations: element.observations,
            pointSalesID: pointSalesID,
            pointSalesName: pointSalesName,
            purchaseCategoryID: purchaseCategoryID,
            purchaseCategoryName: purchaseCategoryName,
            infoPaymentID: infoPaymentID,
            infoPaymentName: infoPaymentName,
            ivaConditionID: 0,
            ivaConditionName: '',
            detIva_net: 0,
            detIva_iva: 0,
            detIva_total: 0,
            perceptionsID: 0,
            perceptionsName: '',
            detPerc_total: 0,
          })

          element.net.forEach(element1 => {
            var ivaConditionID = 0
            var ivaConditionName = ''

            if(element1.iva_condition) {
              ivaConditionID = element1.iva_condition.id
              ivaConditionName = element1.iva_condition.name
            }

            this.arr.export.push({
              ivaConditionID: ivaConditionID,
              ivaConditionName: ivaConditionName,
              detIva_net: element1.amount_net,
              detIva_iva: element1.amoun_iva,
              detIva_total: element1.amount_total,
            })
          })

          element.perceptions.forEach(element2 => {
            var perceptionsID = 0
            var perceptionsName = ''

            if(element2.perceptions) {
              perceptionsID = element2.perceptions.id
              perceptionsName = element2.perceptions.name
            }

            this.arr.export.push({
              perceptionsID: perceptionsID,
              perceptionsName: perceptionsName,
              detPerc_total: element2.amount_total,
            })
          })
        });
      },

      // ABM MAIN
      resetFormFields() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment().format('YYYY-MM-DD')
        this.crud.form.date_imputation = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.suppliers_id = 0
        this.crud.form.suppliers = null
        this.crud.form.currency_id = 0
        this.crud.form.currency = null
        this.crud.form.remits_id = 0
        this.crud.form.remits = null
        this.crud.form.types_vouchers_id = 0
        this.crud.form.types_vouchers = null
        this.crud.form.letter = ''
        this.crud.form.point_sale = 0
        this.crud.form.number = 0
        this.crud.form.invoiceRelated = []
        this.crud.form.points_sales_id = 0
        this.crud.form.points_sales = null
        this.crud.form.purchase_category_id = 0
        this.crud.form.purchase_category = null
        this.crud.form.info_payment_id = 0
        this.crud.form.info_payment = null
        this.crud.form.payment = []
        this.crud.form.showPayment = true
        this.crud.form.ivaDetail = { net: 0, iva: 0, iva_condition_id: 0, iva_condition: null, detail: [] }
        this.crud.form.percepcionesDetail = { percepcion: 0, percepciones_id: 0, percepciones: null, detail: [] }
        this.crud.form.amount_total = 0
        this.resetControl = true
        this.pendingVoucherNameDefault = null
        this.pendingVoucherNamePrefixDefault = null
      },
      add() {
        this.resetFormFields()
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.active = true
        this.modal.form.title = 'Comprobante de Proveedor'
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.date = moment(item.date).format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment(item.date_expiration).format('YYYY-MM-DD')
        this.crud.form.date_imputation = moment(item.date_imputation).format('YYYY-MM-DD')
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.suppliers_id = item.suppliers_id
        this.crud.form.suppliers = item.supplier
        this.crud.form.currency_id = item.currency_id
        this.crud.form.currency = item.currency
        this.crud.form.point_sale = item.point_sale
        this.crud.form.number = item.number
        this.crud.form.points_sales_id = item.points_sales_id
        this.crud.form.points_sales = item.points_sales
        this.crud.form.amount_total = item.amount_total
        this.crud.form.purchase_category_id = item.purchase_category_id
        this.crud.form.purchase_category = item.purchase_category
        this.crud.form.info_payment_id = item.info_payment_id
        this.crud.form.info_payment = item.info_payment
        this.crud.form.payment = []
        this.crud.form.showPayment = true

        this.loadTypeVouchersBySuppliers()
        this.loadConceptsBySupplier(item.supplier)
        this.forceRender()
        this.forceRenderAlt()
        setTimeout(()=>{
          this.crud.form.types_vouchers_id = item.types_vouchers_id
          this.crud.form.types_vouchers = item.type_voucher
          this.crud.form.letter = item.letter


          this.crud.form.ivaDetail = {
            net: 0,
            iva: 0,
            iva_condition_id: 0,
            iva_condition: null,
            detail: [],
          }
          if(item.net) {
            item.net.forEach(element => {
              this.crud.form.ivaDetail.detail.push({
                iva_condition_id: element.iva_conditions_id,
                iva_condition: element.iva_condition,
                net: element.amount_net,
                iva: element.amount_iva,
                total: element.amount_total,
              })
            });
          }

          this.crud.form.percepcionesDetail = {
            percepcion: 0,
            percepciones_id: 0,
            percepciones: null,
            detail: [],
          }
          if(item.perceptions) {
            item.perceptions.forEach(element => {
              this.crud.form.percepcionesDetail.detail.push({
                percepcion: element.amount_total,
                percepciones_id: element.perceptions_id,
                percepciones: element.perception,
              })
            });
          }

          this.crud.form.invoiceRelated = []
          if(item.purchase_related) {
            item.purchase_related.forEach(element => {
              this.crud.form.invoiceRelated.push({
                "type_voucher": element.purchase_related.type_voucher,
                "point_sale": element.purchase_related.point_sale,
                "number": element.purchase_related.number,
                "date": element.purchase_related.date,
                'amount': element.amount_total,
                "id": element.purchase_related.id,
              })
            });
          }

          if(item.accounting_entries) {
            item.accounting_entries.details.forEach(element => {
              if(this.crud.form.conceptsDetails) {
                this.crud.form.conceptsDetails.forEach(concept => {
                  if(element.accounting_accounts_id == concept.accounting_accounts_id) {
                    concept.amount = element.total
                  }
                });
              }
            });
          }
        },1500)

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.active = true
        this.modal.form.title = 'Editar Comprobante de Proveedor'
      },
      remove(item) {
        this.crud.form.id = item.id

        var voucher = "ID #" + item.id
        if(item.type_voucher && item.number) {
          voucher = item.type_voucher.name + ' ' + item.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')
        }

        this.confirmDialog('¿Desea borrar el comprobante ' + voucher + '?', {
          title: 'Borrar Comprobante',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarComprobante(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              // Si el comprobante eliminado es el que está abierto en el
              // drawer, cerrarlo — si no, queda mostrando un registro ya
              // borrado con sus botones todavía activos.
              if(this.itemSelected && this.itemSelected.id === item.id) {
                this.hideSub()
              }
              this.filterPurchase()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      preSave() {
        if(
          !this.crud.form.id &&
          this.crud.form.showPayment &&
          this.crud.form.types_vouchers &&
          this.crud.form.types_vouchers.type_balance == '+'
        ) {
          this.saveAndPayment()
        } else {
          this.save()
        }
      },
      save() {
        this.warnRemitAmountDifferenceBeforeSave()

        this.confirmDialog('¿Desea continuar con la generación del comprobante?', {
          title: 'Generar Comprobante',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = null
            if(this.crud.form.id) {
              result = serviceAPI.editarComprobante(this.crud.form);
            } else {
              result = serviceAPI.agregarComprobante(this.crud.form);
            }

            result.then((response) => {
              const returnToRemits = this.isGenerateFromRemitsRoute()

              this.modal.payment.active = false
              this.resetControl = true
              this.modal.form.active = false

              const finishSave = () => {
                loader.hide()
                this.filterPurchase()
                this.$awn.success("Comprobante generado con éxito");

                if(returnToRemits) {
                  this.$nextTick(() => {
                    this.returnToPurchaseRemits()
                  })
                }
              }

              const linkPromise = this.crud.form.remits_id
                ? this.linkRemitDetailsToPurchase(response.data)
                : Promise.resolve(true)

              linkPromise
                .then(() => {
                  finishSave()
                })
                .catch(() => {
                  finishSave()
                })
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancel() {
        this.confirmDialog('¿Desea cancelar el comprobante?', {
          title: 'Cancelar el Comprobante',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            this.modal.payment.active = false
            this.modal.form.active = false

            this.returnToPurchaseRemits()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      saveAndPayment() {
        this.resetControl = true
        this.modal.payment.title = "Detalle del pago"
        this.modal.payment.active = true
      },
      storeFinances(values) {
        this.crud.form.payment = values
        this.crud.form.payment.totalFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency}).format(this.crud.form.payment.total)
        this.resetControl = false
      },
      cancelPayment() {
        this.modal.payment.active = false
      },
      linkRemitDetailsToPurchase(purchase) {
        if(!purchase || !purchase.id) {
          return Promise.resolve(false)
        }
        if(!this.crud.form.remits) {
          return Promise.resolve(false)
        }

        const details = this.getRemitDetailsForLink(this.crud.form.remits)
        if(!details.length) {
          return Promise.resolve(false)
        }

        return serviceAPI.guardarComprobanteRelacionadosRemitos({
          id: purchase.id,
          details: details,
        }).catch(error => {
          this.$awn.alert(Error.showError(error));
          return false
        })
      },
      warnRemitAmountDifferenceBeforeSave() {
        if(!this.crud.form.remits_id || !this.crud.form.remits) {
          return
        }
        const details = this.getRemitDetailsForLink(this.crud.form.remits)
        if(!details.length) {
          return
        }
        const isInvoiceA = this.crud.form.letter == 'A'
        // Los costos del remito son netos. Para Factura A se compara contra el
        // neto discriminado; para el resto, ambos importes se comparan con IVA.
        const remitTotal = isInvoiceA
          ? this.getRemitDetailsTotal(details)
          : this.getRemitAmountTotal(this.crud.form.remits)
        const invoiceAmount = isInvoiceA
          ? this.getSubtotal()
          : (parseFloat(this.crud.form.amount_total) || 0)
        if(Math.abs(invoiceAmount - remitTotal) > 0.009) {
          const fmt = (n) => Intl.NumberFormat('es-AR', { style: 'currency', currency: this.getCurrency || 'ARS' }).format(n)
          const amountLabel = isInvoiceA ? 'importe neto' : 'importe total'
          this.$awn.info(
            `Mensaje informativo: el ${amountLabel} de la factura (${fmt(invoiceAmount)}) difiere del ${amountLabel} de los ítems del remito (${fmt(remitTotal)}). Se vincularán conservando ambos importes.`
          )
        }
      },
      getRemitDetailsForLink(remit) {
        var items = []
        if(remit.details && remit.details.products) {
          remit.details.products.forEach(element => {
            if(element.id && !element.purchase_id) {
              items.push({
                id: element.id,
                check: true,
                quantity: element.quantity,
                price_cost: element.price_cost
              })
            }
          })
        }
        if(remit.details && remit.details.products_compound) {
          remit.details.products_compound.forEach(element => {
            if(element.id && !element.purchase_id) {
              items.push({
                id: element.id,
                check: true,
                quantity: element.quantity,
                price_cost: element.price_cost
              })
            }
          })
        }
        return items
      },
      getRemitDetailsTotal(details, onlyChecked=true) {
        var total = 0
        if(details && details.length) {
          details.forEach(element => {
            if(!onlyChecked || (element.check != undefined && element.check == true)) {
              var subtotal = parseFloat(element.quantity) * parseFloat(element.price_cost || 0)
              if(!isNaN(subtotal)) {
                total = total + subtotal
              }
            }
          })
        }
        return total
      },
      hasRemitDetailsChecked(details) {
        var valid = false
        if(details && details.length) {
          details.forEach(element => {
            if(element.check!=undefined && element.check == true) {
              valid = true
            }
          });
        }
        return valid
      },
      validateRemitLink(details) {
        if(!this.hasRemitDetailsChecked(details)) {
          this.$awn.alert("No se agregaron items para relacionar");
          return false
        }
        return true
      },
      warnRemitLinkDifference(details, amountNet, existingDetails=[]) {
        // En Factura B/C el neto almacenado incluye IVA y no puede cotejarse
        // con el costo neto del remito ya vinculado sin generar falsos avisos.
        if(!this.itemSelected || this.itemSelected.letter != 'A') {
          return
        }
        var total = this.getRemitDetailsTotal(details)
        if(existingDetails && existingDetails.length) {
          total = total + this.getRemitDetailsTotal(existingDetails, false)
        }

        const invoiceAmount = parseFloat(amountNet) || 0
        if(Math.abs(invoiceAmount - total) > 0.009) {
          const fmt = (n) => Intl.NumberFormat('es-AR', { style: 'currency', currency: this.getCurrency || 'ARS' }).format(n)
          this.$awn.info(
            `Mensaje informativo: el importe neto de la factura (${fmt(invoiceAmount)}) difiere del importe neto de los ítems de remito vinculados (${fmt(total)}). Se vincularán conservando ambos importes.`
          )
        }
      },

      // CALC
      getPendingVoucherPurchase(item) {
        return parseFloat(item.amount_total) - parseFloat(item.amount_impute)
      },

      // PAGO DESDE FACTURA
      // Mismo criterio que la columna "Pendiente": comprobante que suma saldo
      // (factura / ND) y con importe sin imputar.
      canGeneratePayment(item) {
        if(!this.modulePaymentsActive || !item) return false
        if(!item.type_voucher || item.type_voucher.type_balance != '+') return false
        return this.$funciones.compareMoney(this.getPendingVoucherPurchase(item), 0) > 0
      },
      // Abre el alta de pago con la factura ya tildada por su saldo; al
      // guardar o cancelar, payments.vue vuelve a esta vista.
      generatePayment(item) {
        this.hideSub()
        this.$router.push({
          name: 'PaymentsErpStaffPayments',
          query: {
            purchase_id: item.id,
            suppliers_id: item.suppliers_id,
            points_sales_id: item.points_sales_id,
          }
        })
      },

      // ABM VALIDACIONES
      purchaseValidDetailGeneral() {
        if( this.crud.form.suppliers_id &&
            this.crud.form.types_vouchers_id &&
            this.crud.form.letter &&
            this.crud.form.point_sale &&
            this.crud.form.number &&
            this.crud.form.currency_id &&
            this.crud.form.currency &&
            this.crud.form.amount_total) {

          this.loadIvaCondition()
          this.loadPercepciones()

          if(this.crud.form.letter!='A') {
            this.getContabilidad()
          }

          return true;
        } else {
          if(!this.crud.form.suppliers_id) {
            this.$awn.alert("No se cargó el proveedor");
            return false;
          }

          if( !this.crud.form.types_vouchers_id ||
              !this.crud.form.letter ||
              !this.crud.form.point_sale ||
              !this.crud.form.number ) {
            this.$awn.alert("Faltan datos del comprobante");
            return false;
          }

          if(!this.crud.form.currency_id || !this.crud.form.currency) {
            this.$awn.alert("No se cargó la moneda");
            return false;
          }

          if(!this.crud.form.amount_total) {
            this.$awn.alert("No se cargó el importe");
            return false;
          }
        }
      },
      purchaseValidItemDetail() {
        if(this.crud.form.letter=='A') {
          if(this.getDiffTotal() == 0) {
            this.getContabilidad()
            return true;
          } else {
            this.$awn.alert("El saldo declarado no es igual al desglose");
            return false;
          }
        } else {
          this.getContabilidad()
          return true;
        }
      },
      purchaseValidItemConcepts() {
        if(this.getDiffTotalConcepts() == 0) {
          this.getContabilidad()
          return true;
        } else {
          this.$awn.alert("Se encontraron diferencia entre el saldo total y el desgloce por conceptos");
          return false;
        }
      },
      purchaseValidCrudRelation() {
        if(this.crud.form.invoiceRelated.length) {
          const relatedCents = this.crud.form.invoiceRelated.reduce((total, element) => {
            return total + this.$funciones.toCents(element.amount)
          }, 0)

          if(relatedCents !== this.$funciones.toCents(this.crud.form.amount_total)) {
            this.$awn.alert("Falta imputar comprobantes");
            return false;
          } else {
            return true
          }
        } else {
          this.$awn.alert("Es obligatorio vincular una o mas factura a una nota de crédito o débito");
          return false;
        }
      },
      purchaseValidItemAccounting() {
        if(this.crud.form.accountingEntry) {
          return true
        } else {
          this.$awn.alert("Revisar el Asiento Contable");
          return false
        }
      },

      // ABM FLUJO
      loadSuppliers (object) {
        if(!this.crud.form.id) {
          if(object){
            if(this.crud.form.suppliers_id != object.id) {
              this.forceRender()
              this.forceRenderAlt()
            }

            this.crud.form.suppliers = object
            this.crud.form.suppliers_id = object.id

            if(object.data_fiscal) {
              if(object.data_fiscal.points_sales_id) {
                if(!this.crud.form.points_sales_id) {
                  this.crud.form.points_sales = object.data_fiscal.points_sales
                  this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
                }
              }
              if(object.data_fiscal.methods_payment_id) {
                let days = parseInt(object.data_fiscal.methods_payment.term)
                this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
              }
            }

            this.loadTypeVouchersBySuppliers()
            this.loadConceptsBySupplier(object)
          } else {
            this.crud.form.suppliers = null
            this.crud.form.suppliers_id = 0

            this.crud.form.points_sales = null
            this.crud.form.points_sales_id = 0

            this.cleanDataVoucher()
          }
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id

          this.loadTypeVouchersBySuppliers()
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0

          this.cleanDataVoucher()
        }
      },
      loadCurrency (object) {
        if(object){
          this.crud.form.currency = object
          this.crud.form.currency_id = object.id
        } else {
          this.crud.form.currency = null
          this.crud.form.currency_id = 0
        }
      },
      loadPurchaseCategory(object) {
        if(object){
          this.crud.form.purchase_category = object
          this.crud.form.purchase_category_id = object.id
        } else {
          this.crud.form.purchase_category = null
          this.crud.form.purchase_category_id = 0
        }
      },
      loadInfoPayment(object) {
        if(object){
          this.crud.form.info_payment = object
          this.crud.form.info_payment_id = object.id
        } else {
          this.crud.form.info_payment = null
          this.crud.form.info_payment_id = 0
        }
      },
      loadTypeVouchersBySuppliers(referenceDefault=null) {
        if(this.crud.form.suppliers_id && this.crud.form.points_sales_id ) {
          let loader = this.$loading.show();

          this.cleanDataVoucher()
          this.voucherRequestKey = this.voucherRequestKey + 1
          const requestKey = this.voucherRequestKey
          var result = serviceAPI.obtenerVoucherBySupplier({
            suppliers_id: this.crud.form.suppliers_id,
            point_sale_id: this.crud.form.points_sales_id,
          });

          result.then((response) => {
            loader.hide()
            if(requestKey != this.voucherRequestKey) {
              return false
            }
            var data = response.data
            this.arr.typeVouchers = data

            data.forEach(element => {
              this.arr.select.typeVouchers.push({
                value: element.id,
                text: element.name
              })
            });

            this.crud.form.types_vouchers_id = 0
            this.crud.form.letter = ''

            // this.pendingVoucherNameDefault (no el parámetro) porque loadSuppliers()/
            // loadPointsSales() pueden terminar llamando a este método más de una vez en
            // paralelo durante el preset desde remito (una vez por cada FindObject que
            // reacciona) — todas esas llamadas leen el mismo valor pendiente, así que no
            // importa cuál gane la carrera: el resultado final es siempre el mismo.
            // "reference" no sirve para identificar un tipo puntual: varios tipos de
            // comprobante comparten el mismo reference (ej. FACTURA A/B/C todas usan
            // "factura"), así que el default se busca por nombre exacto.
            var nameDefault = this.pendingVoucherNameDefault
            var namePrefixDefault = this.pendingVoucherNamePrefixDefault
            var selectVoucher = null
            if(nameDefault) {
              var target = nameDefault.trim().toUpperCase()
              selectVoucher = data.find(element => (element.name || '').trim().toUpperCase() === target)
            }
            if(!selectVoucher && namePrefixDefault) {
              // No busca "FACTURA A" puntual: toma la primera Factura A/B/C que aparezca
              // en la lista de tipos disponibles para este proveedor+punto de venta (no
              // siempre está la A, depende de la condición fiscal del proveedor).
              var prefix = namePrefixDefault.trim().toUpperCase()
              selectVoucher = data.find(element => (element.name || '').trim().toUpperCase().indexOf(prefix) === 0)
            }
            if(!selectVoucher && referenceDefault) {
              selectVoucher = data.find(element => element.reference == referenceDefault)
            }
            // En una carga manual no hay un tipo preferido: usar el primero
            // habilitado para el proveedor y punto de venta, como punto de partida.
            if(!selectVoucher && data.length) {
              selectVoucher = data[0]
            }
            if(selectVoucher) {
              // setLetter() (no la asignación manual) porque además de letter/types_vouchers_id
              // también repara ivaDetail/percepcionesDetail (cleanDataVoucher(), llamado arriba,
              // los deja en {} sin la clave "detail" que el backend espera) y dispara
              // loadConceptsBySupplier — mismo camino que sigue la selección manual del combo.
              this.setLetter(selectVoucher.id)
            }
          })
          .catch(error => {
            loader.hide()
            if(requestKey != this.voucherRequestKey) {
              return false
            }
            this.$awn.alert(Error.showError(error));
          })
        }
      },
      setLetter(event) {
        if(!this.crud.form.id) {
          var item = null
          this.arr.typeVouchers.forEach(element => {
            if(element.id == event) {
              item = element
            }
          });
          this.crud.form.letter = item.letter
          this.crud.form.types_vouchers_id = item.id
          this.crud.form.types_vouchers = item

          this.crud.form.ivaDetail = {
            net: 0,
            iva: 0,
            iva_condition_id: 0,
            iva_condition: null,
            detail: [],
          }

          this.crud.form.percepcionesDetail = {
            percepcion: 0,
            percepciones_id: 0,
            percepciones: null,
            detail: [],
          }

          this.loadConceptsBySupplier(this.crud.form.suppliers)
        }
      },
      cleanDataVoucher() {
        this.arr.typeVouchers = null
        this.arr.select.typeVouchers = []

        this.crud.form.letter = ''
        this.crud.form.types_vouchers_id = 0
        this.crud.form.types_vouchers = null

        this.crud.form.currency_id = 1
        this.crud.form.currency = {
          id: 1,
          code: 'ARS',
          symbol: '$',
          name: 'Peso',
        }

        this.crud.form.ivaDetail = {}
      },

      // LOAD IVA
      loadIvaCondition() {
        var result = serviceAPI.obtenerIvaCondition();

        result.then((response) => {
          var data = response.data
          this.arr.ivaCondition = data

          this.arr.select.ivaCondition = []
          data.forEach(element => {
            this.arr.select.ivaCondition.push({
              value: element.id,
              text: element.name
            })
          });

          this.crud.form.ivaDetail.iva_condition_id = 5
          this.crud.form.ivaDetail.iva_condition = this.arr.ivaCondition[4]
        })
      },
      changeIvaCondition(event) {
        var item = null
        this.arr.ivaCondition.forEach(element => {
          if(element.id == event) {
            item = element
          }
        });

        if(!item) {
          return
        }

        this.crud.form.ivaDetail.iva_condition_id = item.id
        this.crud.form.ivaDetail.iva_condition = item

        this.crud.form.ivaDetail.iva =  ( parseFloat(this.crud.form.ivaDetail.net) * parseFloat(item.aliquot) ) / 100
        this.crud.form.ivaDetail.iva = parseFloat(this.crud.form.ivaDetail.iva.toFixed(2))
      },
      changeNet() {
        var item = null
        this.arr.ivaCondition.forEach(element => {
          if(element.id == this.crud.form.ivaDetail.iva_condition_id) {
            item = element
          }
        });
        // Sin condición de IVA elegida todavía no hay alícuota para calcular.
        if(!item) return

        this.crud.form.ivaDetail.iva_condition_id = item.id
        this.crud.form.ivaDetail.iva_condition = item

        this.crud.form.ivaDetail.iva =  ( parseFloat(this.crud.form.ivaDetail.net) * parseFloat(item.aliquot) ) / 100
        this.crud.form.ivaDetail.iva = parseFloat(this.crud.form.ivaDetail.iva.toFixed(2))
      },
      addItemIVA()  {
        if(!this.crud.form.ivaDetail.iva_condition_id) {
          this.$awn.alert("No se cargó la condición de IVA");
          return false;
        }

        if(!parseFloat(this.crud.form.ivaDetail.net)) {
          this.$awn.alert("No se cargó el importe neto");
          return false;
        }

        if( !parseFloat(this.crud.form.ivaDetail.iva) &&
            parseFloat(this.crud.form.ivaDetail.iva_condition.aliquot)>0) {
          this.$awn.alert("No se cargó el importe de IVA");
          return false;
        }

        this.crud.form.ivaDetail.detail.push({
          net: this.crud.form.ivaDetail.net,
          iva: this.crud.form.ivaDetail.iva,
          iva_condition: this.crud.form.ivaDetail.iva_condition,
          iva_condition_id: this.crud.form.ivaDetail.iva_condition_id,
        })

        this.crud.form.ivaDetail.net = 0
        this.crud.form.ivaDetail.iva = 0
        this.crud.form.ivaDetail.iva_condition_id = 5
        this.crud.form.ivaDetail.iva_condition = this.arr.ivaCondition[4]
      },
      removeItemIVA(index) {
        this.crud.form.ivaDetail.detail.splice(index, 1)
      },

      // LOAD PERCEPCIONES
      loadPercepciones() {
        var result = serviceAPI.obtenerPercepciones();

        result.then((response) => {
          var data = response.data
          this.arr.percepciones = data

          this.arr.select.percepciones = []
          data.forEach(element => {
            this.arr.select.percepciones.push({
              value: element.id,
              text: element.name
            })
          });
        })
      },
      changePercepciones(event) {
        var item = null
        this.arr.percepciones.forEach(element => {
          if(element.id == event) {
            item = element
          }
        });

        this.crud.form.percepcionesDetail.percepciones_id = item.id
        this.crud.form.percepcionesDetail.percepciones = item
      },
      addItemPercepcion() {
        if(!this.crud.form.percepcionesDetail.percepciones_id) {
          this.$awn.alert("No se cargó la Percepción");
          return false;
        }

        if(!parseFloat(this.crud.form.percepcionesDetail.percepcion)) {
          this.$awn.alert("No se cargó el importe de la Percepción");
          return false;
        }

        var sum = parseFloat(this.crud.form.percepcionesDetail.percepcion)
        this.crud.form.percepcionesDetail.detail.forEach(element => {
          sum = parseFloat(sum) + parseFloat(element.percepcion)
        })
        if(sum>this.crud.form.amount_total) {
          this.$awn.alert("Las percepciones no pueden ser mayor al total de la factura");
          return false;
        }

        this.crud.form.percepcionesDetail.detail.push({
          percepcion: this.crud.form.percepcionesDetail.percepcion,
          percepciones_id: this.crud.form.percepcionesDetail.percepciones_id,
          percepciones: this.crud.form.percepcionesDetail.percepciones,
        })

        this.crud.form.percepcionesDetail.percepcion = 0
        this.crud.form.percepcionesDetail.percepciones_id = 0
        this.crud.form.percepcionesDetail.percepciones = null
      },
      removeItemPercepcion(index) {
        this.crud.form.percepcionesDetail.detail.splice(index, 1)
      },

      // GET TOTALES
      getSubtotal() {
        var sum = 0
        if(this.crud.form.ivaDetail.detail) {
          this.crud.form.ivaDetail.detail.forEach(element => {
            sum = sum + parseFloat(element.net)
          });
        }
        return parseFloat(sum.toFixed(2))
      },
      getIvaTotal() {
        var sum = 0
        if(this.crud.form.ivaDetail.detail) {
          this.crud.form.ivaDetail.detail.forEach(element => {
            sum = sum + parseFloat(element.iva)
          });
        }
        return parseFloat(sum.toFixed(2))
      },
      getPercepcionesTotal() {
        var sum = 0

        if(this.crud.form.percepcionesDetail.detail) {
          this.crud.form.percepcionesDetail.detail.forEach(element => {
            sum = sum + parseFloat(element.percepcion)
          });
        }

        return parseFloat(sum.toFixed(2))
      },
      getTotal() {
        return this.getSubtotal() + this.getIvaTotal() + this.getPercepcionesTotal()
      },
      getDiffTotal() {
        return parseFloat(this.getTotal().toFixed(2)) - parseFloat(parseFloat(this.crud.form.amount_total).toFixed(2))
      },

      // INVOICE RELACIONADA EN NC
      getInvoiceRelated(event) {
        this.crud.form.invoiceRelated = event
      },

      // FILTER
      filterLoad() {
        this.filterLoadSuppliers()
        this.filterLoadCategories()
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.filters.date_end = moment().format('YYYY-MM-DD')

        this.restoreFilterStorage()
      },
      filterLoadSuppliers() {
        var result = serviceAPI.obtenerProveedores()
        result.then((response) => {
          var data = response.data

          this.arr.filters.suppliers = []
          data.forEach(element => {
            this.arr.filters.suppliers.push({ code: element.id, label: element.name })
          });
        })
      },
      filterLoadCategories() {
        serviceAPI.obtenerCategoriaCompra().then((response) => {
          this.arr.filters.categories = (response.data || []).map(element => ({ code: element.id, label: element.name }))
        })
      },
      filterPurchase(forceOpenSub=false) {
        this.saveFilterStorage()
        this.table.isBusy = true
        var result = serviceAPI.filtrarComprobante(this.filters, this.table.currentPage)
        result.then((response) => {

          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data
          this.arr.purchase = data.data
          this.prepareExport(data.data)

          this.table.items.forEach(element => {
            element._rowVariant = this.isPendingPurchase(element) ? 'warning' : null
          });

          // Refresca el drawer preseleccionado con los datos ya actualizados
          // — cualquier acción que modifique el registro tiene que pasar
          // forceOpenSub=true. Guard de itemSelected: la acción puede
          // dispararse con el drawer cerrado (ej. Documento Físico desde el
          // kebab de la fila, no desde el propio drawer).
          this.table.items.forEach(element => {
            if(forceOpenSub && this.itemSelected && element.id == this.itemSelected.id) {
              this.openSub(element)
            }
          });

          if(this.$refs.table) {
            this.$refs.table.$forceUpdate()
          }

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error));
        })
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_crud_purchase', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_crud_purchase')) {
          this.filters = Object.assign({
            date_start: this.filters.date_start,
            date_end: this.filters.date_end,
            suppliers: null,
            categories: null,
            expiration_status: '',
          }, JSON.parse(Storage.getValue('filter_crud_purchase')))
        }
      },

      // COMPROBANTE DETAIL
      openSub(item) {
        this.itemSelected = item

        this.tableSubIva.items = item.net
        this.tableSubPercepcion.items = item.perceptions
        this.tableSubRemits.items = Funciones.groupJSON(item.purchase_remits_detail, 'remit','id')
        this.tableRemits.items = this.itemSelected.purchase_remits_detail

        this.loadImputations(item)
        this.detailDrawer = true
      },
      hideSub() {
        this.tableSubIva.items=[]
        this.tableSubPercepcion.items=[]
        this.itemSelected = null
        this.detailDrawer = false
      },
      // Anterior/siguiente desde el drawer: reusa openSub() con el vecino,
      // así el contenido y el resaltado de fila se actualizan por el mismo
      // camino que un click directo en la tabla.
      goPrevPurchase() {
        if(!this.canGoPrevPurchase) return

        var item = this.table.items[this.currentPurchaseIndex - 1]
        if(item) this.openSub(item)
      },
      goNextPurchase() {
        if(!this.canGoNextPurchase) return

        var item = this.table.items[this.currentPurchaseIndex + 1]
        if(item) this.openSub(item)
      },
      openDetail() {
        this.tableSubIva.items = this.itemSelected.net
        this.tableSubPercepcion.items = this.itemSelected.perceptions
        this.tableRemits.items = this.itemSelected.purchase_remits_detail

        if(this.itemSelected.accounting_entries){
          if(this.itemSelected.accounting_entries.details){
            this.tableAccounting.items = this.itemSelected.accounting_entries.details
          } else {
            this.tableAccounting.items = []
          }
        } else {
          this.tableAccounting.items = []
        }

        this.modal.detail._id = Math.random().toString(36).slice(2, 8)
        this.modal.detail.title = "Detalle del Comprobante"
        this.modal.detail.active = true
      },

      // CONCEPTOS
      loadConceptsBySupplier(object) {
        var data = []
        if(object.accounting_account) {
          var concepts = object.accounting_account.concepts
          if(concepts) {
            concepts.forEach(element => {
              data.push({
                alias: element.alias,
                accounting_accounts_id: element.accounting_accounts_id,
                accounting_accounts: element.accounting_accounts,
                amount: 0,
              })
            });
          }
        }
        this.crud.form.conceptsDetails = data
      },
      getTotalConcepts() {
        var sum = 0
        this.crud.form.conceptsDetails.forEach(element => {
          sum = parseFloat(sum) + parseFloat(element.amount)
        });
        return sum
      },
      getDiffTotalConcepts() {
        if(this.crud.form.letter == 'A') {
          return this.getTotalConcepts() - this.getSubtotal()
        } else {
          return this.getTotalConcepts() - parseFloat(this.crud.form.amount_total)
        }
      },

      // CARGAR ARCHIVO
      openSetFile(item){
        this.itemSelected = item

        this.crud.formFile.id = item.id
        this.crud.formFile.file = null
        this.crud.formFile.fileLink = item.file

        this.modal.formFile.active = true
        this.modal.formFile.title = 'Cargar Documento Físico'
      },
      saveFile() {
        if(!this.crud.formFile.id) {
          this.$awn.alert("No existe el comprobante de compra");
          return false
        }

        this.confirmDialog('¿Desea guardar un documento físico de respaldo para este comprobante?', {
          title: 'Documento Físico',
          icon: 'paperclip',
          okTitle: 'GUARDAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var file = new FormData();
            if(this.crud.formFile.fileLink) {
              file.append("file", this.crud.formFile.fileLink);
            } else {
              if(this.crud.formFile.file) {
                file.append("file", this.crud.formFile.file);
              }
            }

            var result = serviceAPI.agregarAdjuntoCompra(JSON.stringify(this.crud.formFile), file);

            result.then((response) => {
              this.modal.formFile.active = false
              loader.hide()
              this.filterPurchase(true)
              this.$awn.success("Documento guardado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // EDICIÓN RÁPIDA
      loadPurchaseCategoryExtra(object) {
        if(object){
          this.crud.formExtra.purchase_category = object
          this.crud.formExtra.purchase_category_id = object.id
        } else {
          this.crud.formExtra.purchase_category = null
          this.crud.formExtra.purchase_category_id = 0
        }
      },
      loadInfoPaymentExtra(object) {
        if(object){
          this.crud.formExtra.info_payment = object
          this.crud.formExtra.info_payment_id = object.id
        } else {
          this.crud.formExtra.info_payment = null
          this.crud.formExtra.info_payment_id = 0
        }
      },
      openSetExtra(item){
        this.itemSelected = item

        this.crud.formExtra.id = item.id
        this.crud.formExtra.date = item.date ? moment(item.date).format('YYYY-MM-DD') : ''
        this.crud.formExtra.date_expiration = item.date_expiration ? moment(item.date_expiration).format('YYYY-MM-DD') : ''
        this.crud.formExtra.date_imputation = item.date_imputation ? moment(item.date_imputation).format('YYYY-MM-DD') : ''
        this.crud.formExtra.purchase_category_id = item.purchase_category_id
        this.crud.formExtra.purchase_category = item.purchase_category
        this.crud.formExtra.info_payment_id = item.info_payment_id
        this.crud.formExtra.info_payment = item.info_payment
        this.crud.formExtra.observations = item.observations || ''

        this.modal.formExtra.active = true
        this.modal.formExtra.title = 'Edición rápida'
      },
      saveExtra() {
        if(!this.crud.formExtra.id) {
          this.$awn.alert("No existe el comprobante de compra");
          return false
        }

        this.confirmDialog('¿Desea guardar los cambios rápidos de este comprobante?', {
          title: 'Edición rápida',
          icon: 'edit',
          okTitle: 'GUARDAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            serviceAPI.editarComprobanteInfoExtra(this.crud.formExtra)
            .then(() => {
              this.modal.formExtra.active = false
              loader.hide()
              this.filterPurchase(true)
              this.$awn.success("Comprobante actualizado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })

          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },


      // RELACIONAR REMITOS
      openSetRemits(item){
        let loader = this.$loading.show();

        this.itemSelected = item
        this.itemSelectedRemit = []

        var result = serviceAPI.obtenerRemitosSinRelacionar({
          suppliers_id: item.suppliers_id,
          points_sales_id: item.points_sales_id,
        });

        result.then((response) => {
          var data = response.data
          this.itemSelectedRemit = data.filter(element => !element.purchase_id)

          this.modal.formRemits._id = Math.random().toString(36).slice(2, 8)
          this.modal.formRemits.active = true
          this.modal.formRemits.title = 'Relacionar Remito'

          loader.hide()
        })
        .catch(error => {
          loader.hide()
        })
      },
      saveRemits() {
        if(this.itemSelectedRemit && this.itemSelectedRemit.length) {
          if(!this.validateRemitLink(this.itemSelectedRemit)) {
            return false
          }
          this.warnRemitLinkDifference(this.itemSelectedRemit, this.itemSelected.amount_net, this.itemSelected.purchase_remits_detail)
        }

        this.confirmDialog('¿Desea continuar con la relación de los items con el comprobante?', {
          title: 'Relación de Remitos',
          icon: 'truck',
          okTitle: 'RELACIONAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.guardarComprobanteRelacionadosRemitos({
              id: this.itemSelected.id,
              details: this.itemSelectedRemit,
            });

            result.then((response) => {
              this.modal.formRemits.active = false
              loader.hide()
              this.filterPurchase(true)
              this.$awn.success("Items de remitos vinculado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      unlinkRemitsDetail(item) {
        this.confirmDialog('¿Desea desvincular el item de remito del comprobante?', {
          title: 'Desvincular Item de Remito',
          icon: 'link_off',
          danger: true,
          okTitle: 'DESVINCULAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.desvincularDetalleRemito({
              id: item.id,
            });

            result.then((response) => {
              loader.hide()
              this.filterPurchase(true)
              this.$awn.success("Items de remitos desvinculado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      getProductCode(item) {
        var code = ''
        var prod = null

        if(item.products_code) {
          code = item.products_code
        }

        if(item.products_id) {
          if(code) {
            return code
          } else {
            return item.product.code
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }
      },
      getProductName(item) {
        var name = ''
        var prod = null

        if(item.products_name) {
          name = item.products_name
        }

        if(item.products_id) {
          if(name) {
            return name
          } else {
            return item.product.name
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(name) {
            return name + ' (' + prod.color.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ')'
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(name) {
            return name + ' (' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.waist.name + ')'
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(name) {
            return name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          }
        }
      },
      getSummaryRemits() {
        var total = 0
        if(this.itemSelectedRemit) {
          this.itemSelectedRemit.forEach(element => {
            if(element.check != undefined && element.check) {
              total = total + (parseFloat(element.price_cost) * parseFloat(element.quantity))
            }
          });
        }
        return total.toFixed(2)
      },

      // IMPUTATIONS
      loadImputations(item) {
        var arrImputations = []
        if(item.payments) {
          item.payments.forEach(element => {
            arrImputations.push({
              date: element.payment.date,
              reference: element.payment.type_voucher.name + ' ' + element.payment.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.payment.number.toString().padStart(8,'0'),
              amount_total: element.amount_total
            })
          });
        }

        if(item.purchase_related) {
          item.purchase_related.forEach(element => {
            arrImputations.push({
              date: element.purchase_related.date,
              reference: element.purchase_related.type_voucher.name + ' ' + element.purchase_related.point_sale.toString().padStart(4,'0') + '-' + element.purchase_related.number.toString().padStart(8,'0'),
              amount_total: element.amount_total
            })
          });
        }

        if(item.purchase_related_n_c) {
          item.purchase_related_n_c.forEach(element => {
            arrImputations.push({
              date: element.purchase.date,
              reference: element.purchase.type_voucher.name + ' ' + element.purchase.point_sale.toString().padStart(4,'0') + '-' + element.purchase.number.toString().padStart(8,'0'),
              amount_total: element.amount_total
            })
          });
        }

        this.tableImputation.items = arrImputations
      },

      /****************
       * CONTABILIDAD *
       * **************/
      getContabilidad() {
        this.contabilidad.render = false
        this.contabilidad.typeDebe = ""
        this.contabilidad.typeHaber = "",
        this.contabilidad.defaultDebe = []
        this.contabilidad.defaultHaber = []
        this.contabilidad.reference = this.getRefVoucher
        this.contabilidad.amountTotal = parseFloat(this.crud.form.amount_total)

        if( this.crud.form.types_vouchers.reference == 'factura' ||
            this.crud.form.types_vouchers.reference == 'notadebito' ||
            this.crud.form.types_vouchers.reference == 'gasto-nd') {
          this.contabilidad.defaultDebe = this.getContabilidadAsientoCompra('debe')
          this.contabilidad.defaultHaber = this.getContabilidadAsientoCompra('haber')
        }
        if( this.crud.form.types_vouchers.reference == 'notacredito' ||
            this.crud.form.types_vouchers.reference == 'credito-nd') {
          this.contabilidad.defaultDebe = this.getContabilidadAsientoCredito('debe')
          this.contabilidad.defaultHaber = this.getContabilidadAsientoCredito('haber')
        }

        this.contabilidad.render = true
        this.forceUpdate()
      },

      getAsiento(object) {
        this.crud.form.accountingEntry = object
      },
      forceUpdate() {
        this.itemAccountingForceUpdate = this.itemAccountingForceUpdate + 1
      },

      getContabilidadAsientoCompra(type) {
        if(type == 'debe') {
          var arrDebe = []

          if(this.crud.form.conceptsDetails.length) {
            this.crud.form.conceptsDetails.forEach(element => {
              if(parseFloat(element.amount)) {
                arrDebe.push({
                  account: element.accounting_accounts,
                  amount: parseFloat(element.amount),
                  disabled: true,
                })
              }
            });
          } else {
            arrDebe.push({
              account: this.crud.form.suppliers.accounting_account_secondary,
              amount: parseFloat(this.crud.form.amount_total) - parseFloat(this.getIvaTotal()) - parseFloat(this.getPercepcionesTotal()),
              disabled: true,
            })
          }

          if(this.crud.form.ivaDetail.detail) {
            this.crud.form.ivaDetail.detail.forEach(element => {
              arrDebe.push({
                account: element.iva_condition.accounting_account_secondary,
                amount: parseFloat(element.iva),
                disabled: true,
              })
            });
          }

          if(this.crud.form.percepcionesDetail.detail) {
            this.crud.form.percepcionesDetail.detail.forEach(element => {
              arrDebe.push({
                account: element.percepciones.accounting_account_secondary,
                amount: parseFloat(element.percepcion),
                disabled: true,
              })
            });
          }
          return arrDebe
        }

        if(type == 'haber') {
          var arrHaber = [
            {
              account: this.crud.form.suppliers.accounting_account_default,
              amount: parseFloat(this.crud.form.amount_total),
              disabled: true,
            }
          ]

          return arrHaber
        }
      },
      getContabilidadAsientoCredito(type) {
        if(type == 'debe') {
          var arrDebe = [
            {
              account: this.crud.form.suppliers.accounting_account_default,
              amount: parseFloat(this.crud.form.amount_total),
              disabled: true,
            }
          ]

          return arrDebe
        }

        if(type == 'haber') {
          var arrHaber = []

          if(this.crud.form.conceptsDetails.length) {
            this.crud.form.conceptsDetails.forEach(element => {
              if(parseFloat(element.amount)) {
                arrHaber.push({
                  account: element.accounting_accounts,
                  amount: parseFloat(element.amount),
                  disabled: true,
                })
              }
            });
          } else {
            arrHaber.push({
              account: this.crud.form.suppliers.accounting_account_secondary,
              amount: parseFloat(this.crud.form.amount_total) - parseFloat(this.getIvaTotal()) - parseFloat(this.getPercepcionesTotal()),
              disabled: true,
            })
          }

          if(this.crud.form.ivaDetail.detail) {
            this.crud.form.ivaDetail.detail.forEach(element => {
              arrHaber.push({
                account: element.iva_condition.accounting_account_secondary,
                amount: parseFloat(element.iva),
                disabled: true,
              })
            });
          }

          if(this.crud.form.percepcionesDetail.detail) {
            this.crud.form.percepcionesDetail.detail.forEach(element => {
              arrHaber.push({
                account: element.percepciones.accounting_account_secondary,
                amount: parseFloat(element.percepcion),
                disabled: true,
              })
            });
          }

          return arrHaber
        }
      },
    }
  }
</script>
<style>
  .crud-purchase-quick-edit__identity {
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--app-color-border);
  }
  .crud-purchase-quick-edit__dates,
  .crud-purchase-quick-edit__details {
    margin-bottom: 0;
  }
  .crud-purchase-quick-edit__details .form-group,
  .crud-purchase-quick-edit__dates .form-group {
    margin-bottom: 14px;
  }
  .crud-purchase-title {
    font-size: 15px;
    font-weight: 600;
  }
  .crud-purchase-code {
    color: gray;
    font-size: 12px;
  }
  .crud-purchase-wizard .wizard-header {
    padding: 0px;
  }
  .crud-purchase-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-purchase-wizard .wizard-card-footer .wizard-footer-left,
  .crud-purchase-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-purchase-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-purchase-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn::before,
  .crud-purchase-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-purchase-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-purchase-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-purchase-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-purchase-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-purchase-wizard .wizard-footer-left,
    .crud-purchase-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-purchase-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-purchase-wizard .wizard-footer-left > span,
    .crud-purchase-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-purchase-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
  .crud-purchase-item-add {
    margin-top: 30px;
  }
  .crud_purchase_alert_from {
    padding: 5px 10px;
    margin-bottom: 0px;
  }
  .crud-purchase-tax-tabs .nav-tabs {
    border-bottom-color: var(--app-color-border);
  }
  .crud-purchase-tax-tabs .nav-link {
    display: inline-flex;
    align-items: center;
    color: var(--app-color-text-secondary);
  }
  .crud-purchase-tax-tabs .nav-link.active {
    color: var(--app-color-primary);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-tax-tabs .nav-link .badge {
    min-width: 20px;
  }
  .crud-purchase-tax-guide {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
    padding: 8px 10px;
    border: 1px solid var(--app-color-border);
    border-radius: 7px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
    font-size: 0.82rem;
    line-height: 1.45;
  }
  .crud-purchase-tax-guide .app-icon {
    flex: 0 0 auto;
    margin-top: 1px;
    color: var(--app-color-primary);
  }
  .crud-purchase-tax-guide b {
    color: var(--app-color-text);
  }
  .crud-purchase-tax-form {
    padding: 10px 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 7px;
    background: var(--app-color-surface);
  }
  .crud-purchase-tax-form .form-group {
    margin-bottom: 0;
  }
  .crud-purchase-tax-form__add {
    margin-bottom: 1px;
  }
  .crud-purchase-tax-detail {
    margin-top: 12px;
    border-top: 1px solid var(--app-color-border);
  }
  .crud-purchase-tax-table {
    overflow: hidden;
    margin-top: 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 7px;
    background: var(--app-color-surface);
  }
  .crud-purchase-tax-table__heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 34px;
    padding: 6px 10px;
    border-bottom: 1px solid var(--app-color-border);
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-tax-table__heading span {
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }
  .crud-purchase-tax-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border: 1px solid var(--app-color-primary-200);
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-tax-table .app-table {
    margin-bottom: 0;
  }
  .btn.crud-purchase-tax-remove-btn {
    width: 32px;
    height: 32px;
    font-size: 18px;
  }
  .crud-purchase-tax-detail .app-empty-state {
    margin-top: 12px;
  }
  .crud-purchase-voucher-fields {
    padding: 10px 12px 2px;
    border: 1px solid #b7dce8;
    border-radius: 6px;
    background: #f1fbff;
  }
  .crud-purchase-voucher-fields__title {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    color: #17617d;
    font-size: 0.8rem;
    font-weight: var(--app-font-semibold);
  }

  /* Excepción al estándar: esta tabla principal conserva el campo de
     acciones en mobile como link con texto "Opciones" (no ícono-only) —
     ver docs/list-view-interfaces, sección "Excepción: kebab CON texto". */
  .btn.crud-purchase-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-purchase-action-toggle-labeled:hover,
  .btn.crud-purchase-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-purchase-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }

  /* Cajita de totales (Subtotal/IVA/Percepciones/Importe Final/Diferencia)
     del wizard — reemplaza la franja sólida oscura por una card tokenizada
     (ver docs/modal-interfaces, sección 7). */
  .crud-purchase-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-purchase-totals--taxes {
    overflow: hidden;
    padding: 0;
    background: var(--app-color-surface);
  }
  .crud-purchase-totals__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 12px;
    border-bottom: 1px solid var(--app-color-border);
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
  }
  .crud-purchase-totals__header > span:first-child {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: var(--app-color-text);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-totals--taxes .crud-purchase-totals__row {
    padding: 7px 12px;
  }
  .crud-purchase-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
  }
  .crud-purchase-totals__row + .crud-purchase-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-purchase-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-purchase-totals--taxes .crud-purchase-totals__row--total {
    margin-top: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
  }
  .crud-purchase-totals__row--difference {
    font-size: var(--app-text-sm);
  }
  .crud-purchase-totals__row--balanced {
    background: var(--app-color-success-soft);
    color: var(--app-color-success-hover);
  }
  .crud-purchase-totals__row--unbalanced {
    background: var(--app-color-danger-soft);
    color: var(--app-color-danger-hover);
  }
  .crud-purchase-totals__label {
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-purchase-totals__value {
    flex: 0 0 auto;
    white-space: nowrap;
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-drawer-observations {
    margin: 12px 0;
    padding: 10px 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-purchase-drawer-observations .list-view-drawer__section-title {
    margin-bottom: 4px;
  }
  .crud-purchase-detail-observations-row {
    align-items: flex-start;
  }
  .crud-purchase-observations-content {
    min-width: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
</style>
